// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-23T19:57:11.298Z
// Property: Canterbury Downs (ID: 6767906449166884)
// Collections: 27 amenities, 3 floorplans (live), 40 photos, 36 POIs, 5 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166884",
  "property_external_id": "495787",
  "property_zillow_url": "https://www.zillow.com/homedetails/800-Micro-Ct-Roseville-CA-95678/188072296_zpid/",
  "property_apartments_url": "https://www.apartments.com/canterbury-downs-roseville-ca/832tge3/",
  "property_google_business_url": "https://www.google.com/maps/place/Canterbury+Downs+Apartments/data=!4m2!3m1!1s0x0:0xc41035268933540a?sa=X&ved=2ahUKEwjiksGPhbySAxXfBtsEHfiHL8AQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "57248071718",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495787 p0505455",
  "property_status": null,
  "property_slug": "canterbury-downs",
  "property_name": "Canterbury Downs",
  "property_website_url": "http://www.rosevilleapartments.net/",
  "property_domain": "https://www.rosevilleapartments.net/",
  "property_address": "800 Micro Court",
  "property_full_address": "800 Micro Ct, Roseville, CA 95678",
  "property_address_1": "800 Micro Court",
  "property_address_2": null,
  "property_address_city": "Roseville",
  "property_address_state": "CA",
  "property_address_zip_full": null,
  "property_address_zip": "95678",
  "property_address_country": "US",
  "property_address_county": "Placer County",
  "property_neighborhood_address": "Kaseberg - Kingswood",
  "property_address_latitude": "38.7605181",
  "property_address_longitude": "-121.3064647",
  "property_email": "canterburydowns@ctlmanagement.com",
  "property_phone": "18446110142",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Canterbury Downs in Roseville, CA, elevate your lifestyle with spacious one and two-bedroom floor plans. Enjoy amenities like a 24-hour fitness center, swimming pool, and a cozy clubhouse with complimentary Wi-Fi. With beautiful picnic areas, playful playgrounds, and flexible lease terms, your ideal home awaits! Schedule a tour today!",
  "property_long_description": "Welcome to Canterbury Downs, your ideal apartment community nestled in the heart of Roseville, CA. Our thoughtfully designed floor plans feature spacious one and two-bedroom apartments perfect for any lifestyle. Enjoy a wealth of exceptional amenities that make everyday living not just comfortable but enjoyable. \n\nStart your day with a fresh brew at our cozy café seating and coffee bar, or unwind in our pet-friendly community, complete with a beautiful swimming pool and serene picnic areas throughout. Stay active in the 24-hour fitness center, challenge friends to a game on our basketball and racquetball courts, or let the kids explore one of our three playgrounds. \n\nAt Canterbury Downs, you can plug into a vibrant lifestyle with our resident activity program, take advantage of flexible lease terms, and enjoy the convenience of online rent payments and service requests. Each apartment is equipped with centralized heating and air, a full-size washer and dryer, and select units feature vaulted ceilings, a wood-burning fireplace, and beautiful courtyard views.\n\nWith amenities like garages, smoke-free housing, and a welcoming clubhouse with complimentary Wi-Fi, Canterbury Downs offers a community atmosphere where you can truly feel at home. \n\nDon't miss out on the opportunity to join our vibrant community. Find your new home today—browse our availability or schedule a tour to experience all that Canterbury Downs has to offer!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d2b22-6bdb-73f0-8a86-00fe5230d46b.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor swimming pool with lounge chairs and apartment buildings in the background.",
    "public_id": "019d2b22-6bdb-73f0-8a86-00fe5230d46b",
    "storage_key": "property/6767906449166884/019d2b22-6bdb-73f0-8a86-00fe5230d46b.webp",
    "width": 2560,
    "height": 1195
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "173",
  "property_year_built": "1993",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.95375722543352",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $500-600",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Monthly pet rent is per pet.  Small caged animals are allowed without pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Max 2 Allowed | Max weight 25 lb each\nRent $30",
  "property_online_leasing_url": "https://rosevilleapartments.securecafe.com/onlineleasing/canterbury-downs-0/guestlogin",
  "property_resident_portal_url": "https://rosevilleapartments.securecafenet.com/residentservices/canterbury-downs-0/userlogin",
  "property_apply_now_url": "https://rosevilleapartments.securecafe.com/onlineleasing/canterbury-downs-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d73c5-33b5-738b-bba0-9b69682d2576.webp",
  "property_primary_logo_media": {
    "alt_text": "Canterbury Downs Apartments logo",
    "public_id": "019d73c5-33b5-738b-bba0-9b69682d2576",
    "storage_key": "property/6767906449166884/019d73c5-33b5-738b-bba0-9b69682d2576.webp",
    "width": 911,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d73c5-3355-733a-8241-d904b51bee84.webp",
  "property_secondary_logo_media": {
    "alt_text": "Canterbury Downs Apartments logo.",
    "public_id": "019d73c5-3355-733a-8241-d904b51bee84",
    "storage_key": "property/6767906449166884/019d73c5-3355-733a-8241-d904b51bee84.webp",
    "width": 911,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019de0b2-cd49-7778-9474-c19d5c56911c.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Canterbury Downs Apartments logo",
    "public_id": "019de0b2-cd49-7778-9474-c19d5c56911c",
    "storage_key": "property/6767906449166884/019de0b2-cd49-7778-9474-c19d5c56911c.webp",
    "width": 911,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019de0b2-c13b-76a5-9af2-e79abdb4cacf.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Canterbury Downs Apartments logo",
    "public_id": "019de0b2-c13b-76a5-9af2-e79abdb4cacf",
    "storage_key": "property/6767906449166884/019de0b2-c13b-76a5-9af2-e79abdb4cacf.webp",
    "width": 911,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "645 - 892",
  "property_sqft_min": "645",
  "property_sqft_max": "892",
  "property_price_range": "1705 - 2825",
  "property_price_min": "1705",
  "property_price_max": "2825",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/canterburydownsapartments/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJcfo-u6khm4ARClQziSY1EMQ",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/canterbury-downs-apartments-roseville",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Canterbury Downs",
  "property_home_romance_title": "Embrace Life in Your Dream Apartment Community",
  "property_home_amenities_blurb": "Experience the vibrant lifestyle at Canterbury Downs in Roseville, CA, where modern comfort meets community spirit. Enjoy our extensive amenities, from a 24-hour fitness center to picnic areas, and find your perfect home with our versatile floor plans. Embrace a smoke-free haven tailored for your needs. Join us today!",
  "property_home_floorplans_blurb": "Welcome to Canterbury Downs in vibrant Roseville, CA! Our thoughtfully designed apartment floor plans offer a blend of comfort and style, tailored to fit your lifestyle. Dive into a world where spacious living meets modern amenities. Browse our available homes today and discover the ideal layout waiting just for you!",
  "property_home_gallery_blurb": "At Canterbury Downs in Roseville, CA, enjoy spacious one- and two-bedroom floor plans paired with unbeatable amenities. Unwind at the coffee bar, shoot hoops at the basketball court, or take a dip in our refreshing swimming pool. Picture yourself living in comfort and style—your new home awaits!",
  "property_home_neighborhood_blurb": "Welcome to Canterbury Downs, where Roseville living meets vibrant community life. From scenic parks like Maidu and Johnson-Springview to enriching attractions like Sierra College and the Maidu Museum, our neighborhood brims with opportunities for adventure and relaxation. Embrace a lifestyle surrounded by nature and culture, right at your doorstep.",
  "property_home_reviews_blurb": "Welcome to Canterbury Downs in Roseville, CA, where residents celebrate our vibrant community. With glowing reviews highlighting the \"peaceful atmosphere and friendly neighbors,\" it’s easy to see why people love calling us home. See what our residents have to say about living at our community today!",
  "property_neighborhood_blurb": "At Canterbury Downs in Roseville, CA, your vibrant lifestyle meets convenience. Nestled near Sierra College and the Maidu Natural History Museum, you'll find a wealth of parks, fitness centers, and cultural spots. Engage with our community by discovering nearby attractions that enrich your experience and add excitement to everyday living!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Canterbury Downs in Roseville, CA, experience a vibrant lifestyle with diverse floor plans and exceptional amenities. Enjoy relaxing by the pool, engaging with neighbors at our clubhouse, or challenging friends on the basketball court. With modern comforts and inviting communal spaces, your perfect sanctuary awaits. Join us today!",
  "property_applynow_blurb": "At Canterbury Downs in Roseville, CA, our vibrant community boasts spacious one and two-bedroom floor plans, complete with modern amenities. Enjoy a café corner, fitness center, and serene poolside relaxation, all with smoke-free comfort. Embrace flexible living and on-site activities—your ideal home awaits. Lease online today!",
  "property_contactus_blurb": "At Canterbury Downs in Roseville, CA, we offer thoughtfully designed one and two-bedroom floor plans that cater to your unique lifestyle. Our welcoming community is just a call away. Have questions? Our leasing team is ready to assist you today—reach out and let’s find your perfect home!",
  "property_faqs_blurb": "At Canterbury Downs in Roseville, CA, you’ll find the perfect one or two-bedroom apartment to fit your lifestyle. Our FAQs page is your go-to resource for insights about our vibrant community. Get the answers you need and envision your next home today!",
  "property_floorplans_blurb": "Welcome to Canterbury Downs in Roseville, CA, where stylish living meets comfort. Choose from our thoughtfully designed one-bedroom and spacious two-bedroom floor plans that cater to your lifestyle. Browse our available apartment homes and envision your new sanctuary today—design your dream retreat at Canterbury Downs!",
  "property_gallery_blurb": "At Canterbury Downs in Roseville, CA, life unfolds amid vibrant amenities like our sparkling swimming pool, cozy coffee bar, and inviting picnic areas. With spacious one and two-bedroom floor plans, enjoy 24-hour fitness access, resident activities, and stunning courtyard views. Picture yourself living here—your future awaits!",
  "property_interactivemap_blurb": "At Canterbury Downs in Roseville, CA, your ideal apartment awaits! Choose from one or two-bedroom floor plans featuring modern amenities like a vibrant café, cozy fireplaces, and a stunning pool. With our interactive community map, finding your perfect home and enjoying the rich resident experience has never been easier!",
  "property_pets_blurb": "At Canterbury Downs in Roseville, CA, your furry friends are cherished! Enjoy a vibrant community that embraces indoor adult cats and dogs (up to 25 lbs) with ample space to thrive. With minimal pet rent and a welcoming policy for small caged animals, your pets will feel right at home!",
  "property_referafriend_blurb": "At Canterbury Downs in Roseville, CA, we believe great friends make great neighbors! With spacious one- and two-bedroom floor plans tailored to fit your lifestyle, there's a perfect space waiting for you. Share the joy of community living—refer a friend today and elevate your apartment experience together!",
  "property_residentaccess_blurb": "Welcome to Canterbury Downs in Roseville, CA—your cozy haven featuring elegantly designed one and two-bedroom floor plans. Seamlessly manage your living experience: pay rent, request maintenance, and connect with fellow residents through our user-friendly portal. Your comfortable lifestyle starts here; access your resident portal today!",
  "property_reviews_blurb": "At Canterbury Downs in Roseville, CA, residents rave about the vibrant community atmosphere, with one stating it’s “like living in a friendly neighborhood.” Join them and experience the welcoming spirit and remarkable amenities that set us apart. See what our residents have to say about living at our community!",
  "property_created_at": "1762784675925",
  "property_scheduletour_blurb": "At Canterbury Downs in Roseville, CA, our thoughtfully designed floor plans include cozy one-bedroom retreats and spacious two-bedroom homes, perfect for your lifestyle. Schedule a tour today and hear firsthand why our residents cherish their experience in our welcoming community. Your ideal living space awaits!",
  "property_thankyou_blurb": "Thank you for reaching out to Canterbury Downs in beautiful Roseville, CA! Our stylish one and two-bedroom floor plans are designed for comfort and convenience. Anticipate a member of our friendly team contacting you soon to assist you in finding your perfect home. Your journey to vibrant living starts here!",
  "property_virtualtours_blurb": "Step into the inviting charm of Canterbury Downs in Roseville, CA. Our thoughtfully designed one and two-bedroom apartments offer a haven of comfort. Experience the luxury of spacious living with a virtual tour that brings your future home to life. Take your first step toward brighter living today!",
  "property_copyright": "2025 All Rights Reserved. Canterbury Downs",
  "property_seo_title_home": "Canterbury Downs |  Apartments in Roseville, CA",
  "property_seo_description_home": "Experience modern living at Canterbury Downs in Roseville, CA! With luxury amenities, spacious floor plans, and a vibrant community, your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Roseville, CA Apartments for Rent",
  "property_seo_description_floorplans": "Find your perfect fit at Canterbury Downs in Roseville, CA. Browse our diverse one and two-bedroom floor plans—comfort and style await you!",
  "property_seo_title_amenities": "Amenities | Roseville, CA Apartments for Rent",
  "property_seo_description_amenities": "Discover Canterbury Downs in Roseville, CA! Enjoy vibrant amenities, spacious floor plans, and a tailored lifestyle. Experience comfort today!",
  "property_seo_title_gallery": "Gallery | Apartments in Roseville, CA",
  "property_seo_description_gallery": "Uncover the charm of Canterbury Downs in Roseville, CA—an ideal blend of luxury and comfort. Picture your life amidst lush amenities and stunning views!",
  "property_seo_title_virtualtours": "Virtual Tours | Canterbury Downs Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Canterbury Downs in Roseville, CA. Take our virtual tour to envision your future in our inviting one and two-bedroom apartments!",
  "property_seo_title_interactivemap": "Interactive Map | Canterbury Downs Apartments",
  "property_seo_description_interactivemap": "Discover your dream home at Canterbury Downs, Roseville, CA! Use our interactive map to explore floor plans and tailored amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Roseville, CA",
  "property_seo_description_neighborhood": "Experience Roseville living at Canterbury Downs. Uncover charming local favorites and exciting hotspots just steps from your door!",
  "property_seo_title_contact": "Contact Us | Canterbury Downs",
  "property_seo_description_contact": "Connect with the Canterbury Downs team in Roseville, CA! Inquire about our one and two bedroom floor plans—your perfect home awaits. Reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Roseville, CA",
  "property_seo_description_faqs": "Uncover answers to your queries at Canterbury Downs in Roseville, CA. Dive into our FAQs and learn about our vibrant community and exceptional amenities!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Roseville, CA",
  "property_seo_description_reviews": "Experience the charm of Canterbury Downs in Roseville, CA. Hear firsthand why residents love our amenities, community vibe, and cozy floor plans. Join us!",
  "property_seo_title_applynow": "Apply Now | Apartments in Roseville, CA",
  "property_seo_description_applynow": "Find your ideal space at Canterbury Downs in Roseville, CA—offering cozy one & two-bedroom designs, amazing amenities, and flexible lease options. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Canterbury Downs",
  "property_seo_description_residentaccess": "Easily manage your Canterbury Downs living in Roseville, CA. Log in for rent payments, maintenance requests, and exclusive updates!",
  "property_seo_title_referafriend": "Refer A Friend | Canterbury Downs",
  "property_seo_description_referafriend": "Refer a friend to Canterbury Downs in Roseville, CA! Great friends make great neighbors. Join our vibrant community and enjoy exclusive rewards today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Canterbury Downs",
  "property_seo_description_scheduletour": "Experience the charm of Canterbury Downs in Roseville, CA. Schedule your tour today and envision your new life in our welcoming apartment community!",
  "property_seo_title_privacy": "Privacy Policy | Canterbury Downs",
  "property_seo_description_privacy": "At Canterbury Downs in Roseville, CA, your privacy matters. Delve into our policy to learn how we safeguard your personal information. View now!",
  "property_seo_title_accessibility": "Website Accessibility | Canterbury Downs",
  "property_seo_description_accessibility": "Canterbury Downs in Roseville, CA champions digital inclusion, ensuring everyone can enjoy seamless access to our vibrant community. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Canterbury Downs",
  "property_seo_description_sitemap": "Uncover the charm of Canterbury Downs in Roseville, CA. Browse our sitemap for easy access to amenities, floor plans, and all the community has to offer!",
  "property_seo_title_thankyou": "Thank You | Canterbury Downs",
  "property_seo_description_thankyou": "Thank you for reaching out! A member of the Canterbury Downs team in Roseville, CA will connect with you soon—your new home awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Roseville, CA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1778874562332",
  "amenities": [
    {
      "id": "ec_511057e8f667a4ef09a0fb89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "80428629",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d9a47-abfb-752a-b058-1f5123124fdd.webp",
      "amenity_image_media": {
        "alt_text": "Gym equipment including treadmills, ellipticals, and weight machines.",
        "public_id": "019d9a47-abfb-752a-b058-1f5123124fdd",
        "storage_key": "property/6767906449166884/019d9a47-abfb-752a-b058-1f5123124fdd.webp",
        "width": 1650,
        "height": 1098
      },
      "amenity_image_alt_text": "Canterbury Downs Fitness Center & Equipment",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_afa7ea463b54eb82995056d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "80428635",
      "title": "Racquetball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d496a-8ca4-719f-b64c-61568a2f4446.webp",
      "amenity_image_media": {
        "alt_text": "Indoor racquetball court with glass walls and wood floor.",
        "public_id": "019d496a-8ca4-719f-b64c-61568a2f4446",
        "storage_key": "property/6767906449166884/019d496a-8ca4-719f-b64c-61568a2f4446.webp",
        "width": 1650,
        "height": 1098
      },
      "amenity_image_alt_text": "Canterbury Downs Racquetball Court",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76f631859a5634f3185adc4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "80428632",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_23facbffdf9c430e35a577bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "80428637",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d497f-c265-760a-871d-082527db5699.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019d497f-c265-760a-871d-082527db5699",
        "storage_key": "property/6767906449166884/019d497f-c265-760a-871d-082527db5699.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Canterbury Downs swimming pool deck, Roseville, CA, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16351f83e8555484be8adcd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "80428636",
      "title": "Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d497f-445c-73da-8ad7-b2e77dad5630.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool and hot tub with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d497f-445c-73da-8ad7-b2e77dad5630",
        "storage_key": "property/6767906449166884/019d497f-445c-73da-8ad7-b2e77dad5630.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Canterbury Downs swimming pool and spa, Roseville, CA, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b5397741a3d14151b1ded912",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "80428631",
      "title": "3 Playgrounds",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d497f-9a42-747e-bb29-4bcd7b9e98e9.webp",
      "amenity_image_media": {
        "alt_text": "Playground with slides and climbing structure.",
        "public_id": "019d497f-9a42-747e-bb29-4bcd7b9e98e9",
        "storage_key": "property/6767906449166884/019d497f-9a42-747e-bb29-4bcd7b9e98e9.webp",
        "width": 1500,
        "height": 1001
      },
      "amenity_image_alt_text": "Canterbury Downs Outdoor Playground,Canterbury Downs Swing Set,Canterbury Downs Playground Picnic Area",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73ee52eebcdf95f5ec7822f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "80428633",
      "title": "Picnic Areas Throughout",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d497f-bc47-71bc-864a-95876a1ab736.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor seating area with picnic tables under a wooden pergola.",
        "public_id": "019d497f-bc47-71bc-864a-95876a1ab736",
        "storage_key": "property/6767906449166884/019d497f-bc47-71bc-864a-95876a1ab736.webp",
        "width": 1500,
        "height": 1001
      },
      "amenity_image_alt_text": "Canterbury Downs BBQ Picnic Area",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ae5892b00d83be7318306915",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "80428643",
      "title": "Garages",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4980-067b-74bd-945d-93ddb848e99a.webp",
      "amenity_image_media": {
        "alt_text": "Multiple attached garage doors with numbered bays.",
        "public_id": "019d4980-067b-74bd-945d-93ddb848e99a",
        "storage_key": "property/6767906449166884/019d4980-067b-74bd-945d-93ddb848e99a.webp",
        "width": 1500,
        "height": 1001
      },
      "amenity_image_alt_text": "Canterbury Downs Garage Exteriors",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aeeb959cf0ca776dd59155a4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "86392928",
      "title": "Clubhouse with Complimentary Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4ccc-d8e8-7309-aa50-2ea5c4090e72.webp",
      "amenity_image_media": {
        "alt_text": "Spacious seating area with a fireplace and welcome sign.",
        "public_id": "019d4ccc-d8e8-7309-aa50-2ea5c4090e72",
        "storage_key": "property/6767906449166884/019d4ccc-d8e8-7309-aa50-2ea5c4090e72.webp",
        "width": 3072,
        "height": 2053
      },
      "amenity_image_alt_text": "Canterbury Downs clubhouse fireside lounge side view,Canterbury Downs clubhouse fireside lounge",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_45c39d044611715110fc3a0e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "86392913",
      "title": "Cafe Seating & Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d497f-3ed8-718d-84a2-7867171c2d25.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen and dining area in apartment",
        "public_id": "019d497f-3ed8-718d-84a2-7867171c2d25",
        "storage_key": "property/6767906449166884/019d497f-3ed8-718d-84a2-7867171c2d25.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Canterbury Downs clubhouse kitchen, Roseville, CA, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b9e33ce17c79e7798a3a682",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "86392925",
      "title": "Package Acceptance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7bb95b8d9608f3519944b33f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "86392955",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9fcd43714c1fa9c80c605c44",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "86392956",
      "title": "Flexible Lease Terms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0e6273dbb33e8baf77846563",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "80428634",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d9513de108fe5d983842fc65",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "82390131",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bf4fec2823657c6493ad62b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "82390132",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24abc17751bc985571e78701",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "80428642",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4969-be71-7009-8583-d0ced8261a31.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a bed and laundry area with washer and dryer.",
        "public_id": "019d4969-be71-7009-8583-d0ced8261a31",
        "storage_key": "property/6767906449166884/019d4969-be71-7009-8583-d0ced8261a31.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Canterbury Downs model washer and dryer, Roseville, CA, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_93f3b679e4da337df272a360",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "80428640",
      "title": "Centralized Heating And Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4969-6816-732b-a9f3-79be3e760c2c.webp",
      "amenity_image_media": {
        "alt_text": "Living room and dining area with a sofa, coffee table, dining table, and chairs.",
        "public_id": "019d4969-6816-732b-a9f3-79be3e760c2c",
        "storage_key": "property/6767906449166884/019d4969-6816-732b-a9f3-79be3e760c2c.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Canterbury Downs model dining room and living room, Roseville, CA, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6aa4b6730da839c3932e77b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "80428647",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d496a-2134-7798-b772-fec24c437f94.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with closet and view into bathroom",
        "public_id": "019d496a-2134-7798-b772-fec24c437f94",
        "storage_key": "property/6767906449166884/019d496a-2134-7798-b772-fec24c437f94.webp",
        "width": 1650,
        "height": 1098
      },
      "amenity_image_alt_text": "Canterbury Downs Vacant Master Bedroom With Bathroom & Walk In Closet",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ee5b87a4d2f423ddc351f223",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "80428644",
      "title": "Gas Ranges",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56b1a6aeb61a1c531695c3e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "80428648",
      "title": "Wood Burning Fireplace - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8b48da8e3e6ce8ee71bcfa0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "80428639",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4969-91d9-73c3-892f-1f092522e27c.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
        "public_id": "019d4969-91d9-73c3-892f-1f092522e27c",
        "storage_key": "property/6767906449166884/019d4969-91d9-73c3-892f-1f092522e27c.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Canterbury Downs model primary bedroom, Roseville, CA, 95678,Canterbury Downs model living spaces kitchen dining room and living room, Roseville, CA, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_15d574976d1af721647de9d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "80428646",
      "title": "Vaulted Ceilings - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d496a-10d6-75aa-85c8-62b4c2cc76f1.webp",
      "amenity_image_media": {
        "alt_text": "Living area and kitchen view in an apartment with a ceiling fan and vaulted ceilings.",
        "public_id": "019d496a-10d6-75aa-85c8-62b4c2cc76f1",
        "storage_key": "property/6767906449166884/019d496a-10d6-75aa-85c8-62b4c2cc76f1.webp",
        "width": 1650,
        "height": 1098
      },
      "amenity_image_alt_text": "Canterbury Downs Vacant Living Room",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de8c469153e9ada463aa80cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "80428641",
      "title": "Courtyard Views*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_84e2ed106a8a2247fc1dc199",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "80428645",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4969-2995-77e8-a6c8-f47ae2cc7160.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen with light wood cabinets, white appliances, and granite countertops.",
        "public_id": "019d4969-2995-77e8-a6c8-f47ae2cc7160",
        "storage_key": "property/6767906449166884/019d4969-2995-77e8-a6c8-f47ae2cc7160.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Canterbury Downs model kitchen, Roseville, CA, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_06f875bf957441c4aa491d89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "87310400",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d496a-1e1a-77f9-8e52-25ea67a51add.webp",
      "amenity_image_media": {
        "alt_text": "Private patio with two chairs, a small table, and a welcome mat outside apartment 605.",
        "public_id": "019d496a-1e1a-77f9-8e52-25ea67a51add",
        "storage_key": "property/6767906449166884/019d496a-1e1a-77f9-8e52-25ea67a51add.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Canterbury Downs model patio, Roseville, CA, 95678",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_311d3b7d078c15faf750631f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "yardi",
      "external_id": "89410747",
      "title": "Top Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_9411af28f291d6bba9e5ec08",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d42a2-0203-741f-87c1-65814529dad6.webp",
      "image_media": {
        "alt_text": "Canterbury Downs Apartments entrance with a water feature and lush landscaping.",
        "public_id": "019d42a2-0203-741f-87c1-65814529dad6",
        "storage_key": "property/6767906449166884/019d42a2-0203-741f-87c1-65814529dad6.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Welcome to Canterbury Downs Apartments, featuring a beautiful water fountain and serene landscaping at the property entrance.",
      "link": "false",
      "alt_text": "Canterbury Downs Apartments entrance with a water feature and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_MonumentSign.jpg"
    },
    {
      "id": "ec_9ce5d460ec82c6bd8d73dd54",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4969-2995-77e8-a6c8-f47ae2cc7160.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, white appliances, and granite countertops.",
        "public_id": "019d4969-2995-77e8-a6c8-f47ae2cc7160",
        "storage_key": "property/6767906449166884/019d4969-2995-77e8-a6c8-f47ae2cc7160.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Fully equipped kitchen featuring ample cabinet space, granite countertops, a gas range, and a dishwasher for your convenience.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, white appliances, and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_ModelKitchen(1).jpg"
    },
    {
      "id": "ec_756cfa3109599cec2ccb93ed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4969-2a5a-7425-ad9b-80b8e4170983.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, granite countertops, and a stainless steel sink.",
        "public_id": "019d4969-2a5a-7425-ad9b-80b8e4170983",
        "storage_key": "property/6767906449166884/019d4969-2a5a-7425-ad9b-80b8e4170983.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring light wood cabinetry, granite countertops, a stainless steel sink, and a microwave. The open layout includes a pass-through to the dining or living area.",
      "link": "false",
      "alt_text": "Kitchen with light wood cabinets, granite countertops, and a stainless steel sink.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_ModelKitchenBar.jpg"
    },
    {
      "id": "ec_4f70fe1937461d5135e8fec7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4969-4ace-71b1-b22b-60099b87fe39.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with a white refrigerator, gas stove, and a dining table with four chairs.",
        "public_id": "019d4969-4ace-71b1-b22b-60099b87fe39",
        "storage_key": "property/6767906449166884/019d4969-4ace-71b1-b22b-60099b87fe39.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "View of a spacious kitchen and dining area, featuring modern appliances and a comfortable dining space perfect for family meals.",
      "link": "false",
      "alt_text": "Kitchen and dining area with a white refrigerator, gas stove, and a dining table with four chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_ModelDiningRoom(1).jpg"
    },
    {
      "id": "ec_6ec97896bc39861f7edf7c16",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4969-2b82-759d-9c9e-39c01d1abf0b.webp",
      "image_media": {
        "alt_text": "Living area with dining and kitchen views",
        "public_id": "019d4969-2b82-759d-9c9e-39c01d1abf0b",
        "storage_key": "property/6767906449166884/019d4969-2b82-759d-9c9e-39c01d1abf0b.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Stylish living area with a dining space and a glimpse of the kitchen, perfect for a comfortable and modern lifestyle.",
      "link": "false",
      "alt_text": "Living area with dining and kitchen views",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_ModelLivingSpaces.jpg"
    },
    {
      "id": "ec_3f6897e6795607d4f6b3ee91",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4969-6816-732b-a9f3-79be3e760c2c.webp",
      "image_media": {
        "alt_text": "Living room and dining area with a sofa, coffee table, dining table, and chairs.",
        "public_id": "019d4969-6816-732b-a9f3-79be3e760c2c",
        "storage_key": "property/6767906449166884/019d4969-6816-732b-a9f3-79be3e760c2c.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Stylish living and dining space featuring a comfortable sofa, elegant dining set, and tasteful decor. Perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "Living room and dining area with a sofa, coffee table, dining table, and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_ModelDiningRoomLivingRoom.jpg"
    },
    {
      "id": "ec_f18eeb84f07f14fc6671e8f7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4969-9058-7304-9823-581bcb15afc1.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, armchair, and a decorative mirror.",
        "public_id": "019d4969-9058-7304-9823-581bcb15afc1",
        "storage_key": "property/6767906449166884/019d4969-9058-7304-9823-581bcb15afc1.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious living room with modern furnishings, including a comfortable sofa and armchair, perfect for relaxation and entertaining guests.",
      "link": "false",
      "alt_text": "Living room with a sofa, coffee table, armchair, and a decorative mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_ModelLivingRoom.jpg"
    },
    {
      "id": "ec_a4cd2b9ac30f6546129b6d97",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4969-91d9-73c3-892f-1f092522e27c.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
        "public_id": "019d4969-91d9-73c3-892f-1f092522e27c",
        "storage_key": "property/6767906449166884/019d4969-91d9-73c3-892f-1f092522e27c.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed with plush bedding, a stylish nightstand with a lamp, and a large window with vertical blinds.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_ModelPrimaryBedroom.jpg"
    },
    {
      "id": "ec_37c49441934cdd17ad12205a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4969-a6f0-7319-9b24-c5042ec709cf.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, mirrored closet, and ceiling fan.",
        "public_id": "019d4969-a6f0-7319-9b24-c5042ec709cf",
        "storage_key": "property/6767906449166884/019d4969-a6f0-7319-9b24-c5042ec709cf.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Step into comfort in this spacious bedroom, featuring a plush king-size bed, ample closet space with mirrored doors, and a ceiling fan for ultimate relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, mirrored closet, and ceiling fan.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_ModelPrimaryBedroomCloset.jpg"
    },
    {
      "id": "ec_a8bd18467dce772a9d711a45",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4969-be71-7009-8583-d0ced8261a31.webp",
      "image_media": {
        "alt_text": "Bedroom with a bed and laundry area with washer and dryer.",
        "public_id": "019d4969-be71-7009-8583-d0ced8261a31",
        "storage_key": "property/6767906449166884/019d4969-be71-7009-8583-d0ced8261a31.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "A comfortable bedroom featuring a queen-size bed with plush bedding, complemented by a convenient in-unit laundry area with a washer and dryer.",
      "link": "false",
      "alt_text": "Bedroom with a bed and laundry area with washer and dryer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_ModelWasherDryer(1).jpg"
    },
    {
      "id": "ec_6bcecaaea9cc85ac74dd45da",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d496a-0075-770d-9d76-641f59df44f2.webp",
      "image_media": {
        "alt_text": "Bedroom with a closet, a desk with a chair, and a bed with pillows.",
        "public_id": "019d496a-0075-770d-9d76-641f59df44f2",
        "storage_key": "property/6767906449166884/019d496a-0075-770d-9d76-641f59df44f2.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "This bedroom features a spacious closet, a comfortable bed, and a stylish desk area, perfect for work or study.",
      "link": "false",
      "alt_text": "Bedroom with a closet, a desk with a chair, and a bed with pillows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_ModelSecondBedroom.jpg"
    },
    {
      "id": "ec_1541f251d9db03c9617d47d3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d496a-27e4-7664-943d-9c5f20092db1.webp",
      "image_media": {
        "alt_text": "Bathroom with a bathtub, shower curtain, toilet, vanity, and mirror.",
        "public_id": "019d496a-27e4-7664-943d-9c5f20092db1",
        "storage_key": "property/6767906449166884/019d496a-27e4-7664-943d-9c5f20092db1.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "A clean and modern bathroom featuring a bathtub with a shower curtain, toilet, vanity with a granite countertop, and a large mirror. Decorated with abstract art and a vase of yellow flowers.",
      "link": "false",
      "alt_text": "Bathroom with a bathtub, shower curtain, toilet, vanity, and mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_ModelBathroom.jpg"
    },
    {
      "id": "ec_60089c8a66b20b246d4a2c9b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d496a-1e1a-77f9-8e52-25ea67a51add.webp",
      "image_media": {
        "alt_text": "Private patio with two chairs, a small table, and a welcome mat outside apartment 605.",
        "public_id": "019d496a-1e1a-77f9-8e52-25ea67a51add",
        "storage_key": "property/6767906449166884/019d496a-1e1a-77f9-8e52-25ea67a51add.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Enjoy your private patio, perfect for relaxing or entertaining. This outdoor space features comfortable seating and a welcoming ambiance.",
      "link": "false",
      "alt_text": "Private patio with two chairs, a small table, and a welcome mat outside apartment 605.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_ModelPatio.jpg"
    },
    {
      "id": "ec_149e6b0fa65a58d547ba5b04",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d496a-03f6-73bb-8c6e-f173aa9c5ba3.webp",
      "image_media": {
        "alt_text": "Kitchen with wooden cabinets, white refrigerator, and white stove.",
        "public_id": "019d496a-03f6-73bb-8c6e-f173aa9c5ba3",
        "storage_key": "property/6767906449166884/019d496a-03f6-73bb-8c6e-f173aa9c5ba3.webp",
        "width": 1650,
        "height": 1098
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring ample wooden cabinetry, a white refrigerator, and a white gas range.",
      "link": "false",
      "alt_text": "Kitchen with wooden cabinets, white refrigerator, and white stove.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_VacantUpgradedKitchen.jpg"
    },
    {
      "id": "ec_21fc40ed85c4080c2bc3aed7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d496a-10d6-75aa-85c8-62b4c2cc76f1.webp",
      "image_media": {
        "alt_text": "Living area and kitchen view in an apartment with a ceiling fan and vaulted ceilings.",
        "public_id": "019d496a-10d6-75aa-85c8-62b4c2cc76f1",
        "storage_key": "property/6767906449166884/019d496a-10d6-75aa-85c8-62b4c2cc76f1.webp",
        "width": 1650,
        "height": 1098
      },
      "title": "Apartment",
      "description": "Spacious living area with a view into the kitchen, featuring vaulted ceilings and a ceiling fan. Perfect for comfortable living.",
      "link": "false",
      "alt_text": "Living area and kitchen view in an apartment with a ceiling fan and vaulted ceilings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_VacantLivingRoom.jpg"
    },
    {
      "id": "ec_d315b967c6944a1b54740195",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d496a-2134-7798-b772-fec24c437f94.webp",
      "image_media": {
        "alt_text": "Bedroom with closet and view into bathroom",
        "public_id": "019d496a-2134-7798-b772-fec24c437f94",
        "storage_key": "property/6767906449166884/019d496a-2134-7798-b772-fec24c437f94.webp",
        "width": 1650,
        "height": 1098
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a walk-in closet and an en-suite bathroom.",
      "link": "false",
      "alt_text": "Bedroom with closet and view into bathroom",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_VacantMasterBedroom.jpg"
    },
    {
      "id": "ec_ba07d37b4def5869850e97c9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d496a-41a4-737f-bc1a-41545332f848.webp",
      "image_media": {
        "alt_text": "Bedroom with mirrored closet doors and a large window.",
        "public_id": "019d496a-41a4-737f-bc1a-41545332f848",
        "storage_key": "property/6767906449166884/019d496a-41a4-737f-bc1a-41545332f848.webp",
        "width": 1650,
        "height": 1098
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large window for natural light and mirrored closet doors for a sense of openness. Carpeted floors provide comfort.",
      "link": "false",
      "alt_text": "Bedroom with mirrored closet doors and a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_VacantSecondBedroom.jpg"
    },
    {
      "id": "ec_6c9dd02667f64151136edddc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d496a-48bf-7396-9004-5042687cddfc.webp",
      "image_media": {
        "alt_text": "Closet with stacked washer and dryer.",
        "public_id": "019d496a-48bf-7396-9004-5042687cddfc",
        "storage_key": "property/6767906449166884/019d496a-48bf-7396-9004-5042687cddfc.webp",
        "width": 1650,
        "height": 1098
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for convenient laundry access.",
      "link": "false",
      "alt_text": "Closet with stacked washer and dryer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_VacantWasherDryer02.jpg"
    },
    {
      "id": "ec_43564fa737e812ebab6a20e8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d496a-5030-723b-a91c-195554eaba75.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub, toilet, and vanity.",
        "public_id": "019d496a-5030-723b-a91c-195554eaba75",
        "storage_key": "property/6767906449166884/019d496a-5030-723b-a91c-195554eaba75.webp",
        "width": 1650,
        "height": 1098
      },
      "title": "Apartment",
      "description": "A spacious bathroom featuring a bathtub, toilet, and a wooden vanity with a granite countertop. The room is finished with tiled flooring.",
      "link": "false",
      "alt_text": "Bathroom with bathtub, toilet, and vanity.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_VacantSecondBathroom.jpg"
    },
    {
      "id": "ec_5f18a77a78a291b5c68b464b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d496a-6224-763d-b8ee-847b4a4c050d.webp",
      "image_media": {
        "alt_text": "Exterior of the leasing office entrance at a multifamily property.",
        "public_id": "019d496a-6224-763d-b8ee-847b4a4c050d",
        "storage_key": "property/6767906449166884/019d496a-6224-763d-b8ee-847b4a4c050d.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "The leasing office entrance is the hub of resident services and community engagement.",
      "link": "false",
      "alt_text": "Exterior of the leasing office entrance at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_ClubhouseEntryParkingLot.jpg"
    },
    {
      "id": "ec_f8432de75681df3a6cd7c782",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4ccc-d8e7-70ed-ba12-8eec053c2713.webp",
      "image_media": {
        "alt_text": "Cozy living room with fireplace and two sofas.",
        "public_id": "019d4ccc-d8e7-70ed-ba12-8eec053c2713",
        "storage_key": "property/6767906449166884/019d4ccc-d8e7-70ed-ba12-8eec053c2713.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable living room, perfect for gatherings or quiet evenings by the fire.",
      "link": "false",
      "alt_text": "Cozy living room with fireplace and two sofas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_ClubhouseFiresideLounge1.jpg"
    },
    {
      "id": "ec_ac59f6090c0f669535d3f54c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4ccc-d8e8-7309-aa50-2ea5c4090e72.webp",
      "image_media": {
        "alt_text": "Spacious seating area with a fireplace and welcome sign.",
        "public_id": "019d4ccc-d8e8-7309-aa50-2ea5c4090e72",
        "storage_key": "property/6767906449166884/019d4ccc-d8e8-7309-aa50-2ea5c4090e72.webp",
        "width": 3072,
        "height": 2053
      },
      "title": "Community",
      "description": "Relax in the beautifully appointed community lounge, featuring comfortable seating, a modern fireplace, and a welcoming atmosphere.",
      "link": "false",
      "alt_text": "Spacious seating area with a fireplace and welcome sign.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_ClubhouseFiresideLounge2.jpg"
    },
    {
      "id": "ec_d1879071e3ef145dad594c72",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d497f-3ed8-718d-84a2-7867171c2d25.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area in apartment",
        "public_id": "019d497f-3ed8-718d-84a2-7867171c2d25",
        "storage_key": "property/6767906449166884/019d497f-3ed8-718d-84a2-7867171c2d25.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "A spacious kitchen and dining area with modern appliances and comfortable seating, perfect for entertaining guests or enjoying a quiet meal.",
      "link": "false",
      "alt_text": "Kitchen and dining area in apartment",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_ClubhouseKitchen.jpg"
    },
    {
      "id": "ec_38bdc647998d26aaf9188c15",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d497f-3edf-73a8-877b-ce33ecd5d453.webp",
      "image_media": {
        "alt_text": "Business center with desks, chairs, computers, and printer.",
        "public_id": "019d497f-3edf-73a8-877b-ce33ecd5d453",
        "storage_key": "property/6767906449166884/019d497f-3edf-73a8-877b-ce33ecd5d453.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Utilize our convenient business center, equipped with computers and a printer, to stay connected and productive.",
      "link": "false",
      "alt_text": "Business center with desks, chairs, computers, and printer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_BusinessCenter.jpg"
    },
    {
      "id": "ec_6221e40abd7c5fa4158c4ff1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d496a-8ca4-719f-b64c-61568a2f4446.webp",
      "image_media": {
        "alt_text": "Indoor racquetball court with glass walls and wood floor.",
        "public_id": "019d496a-8ca4-719f-b64c-61568a2f4446",
        "storage_key": "property/6767906449166884/019d496a-8ca4-719f-b64c-61568a2f4446.webp",
        "width": 1650,
        "height": 1098
      },
      "title": "Community",
      "description": "Enjoy an active lifestyle with our indoor racquetball court, perfect for a quick game or a full workout.",
      "link": "false",
      "alt_text": "Indoor racquetball court with glass walls and wood floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_RacquetballCourt02.jpg"
    },
    {
      "id": "ec_8e3735c612552eb2f203059b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d497f-3f31-77fc-a149-0bf21b5fce99.webp",
      "image_media": {
        "alt_text": "Apartment community pool with lounge chairs and a small pond with a fountain in the foreground.",
        "public_id": "019d497f-3f31-77fc-a149-0bf21b5fce99",
        "storage_key": "property/6767906449166884/019d497f-3f31-77fc-a149-0bf21b5fce99.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, surrounded by lush landscaping and comfortable lounge chairs. A charming water feature adds to the serene ambiance.",
      "link": "false",
      "alt_text": "Apartment community pool with lounge chairs and a small pond with a fountain in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_SwimmingPoolFountain.jpg"
    },
    {
      "id": "ec_421974c4a766c883b6fb18b4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d496a-99c1-7773-bd3e-9e191713f6a7.webp",
      "image_media": {
        "alt_text": "View of the swimming pool and courtyard with a fountain.",
        "public_id": "019d496a-99c1-7773-bd3e-9e191713f6a7",
        "storage_key": "property/6767906449166884/019d496a-99c1-7773-bd3e-9e191713f6a7.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and a tranquil fountain.",
      "link": "false",
      "alt_text": "View of the swimming pool and courtyard with a fountain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_SecondPoolFountain.jpg"
    },
    {
      "id": "ec_a11d8285e3f62f155d141767",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d497f-445c-73da-8ad7-b2e77dad5630.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and hot tub with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d497f-445c-73da-8ad7-b2e77dad5630",
        "storage_key": "property/6767906449166884/019d497f-445c-73da-8ad7-b2e77dad5630.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim or relax in the hot tub at our sparkling outdoor pool. Perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "Resort-style swimming pool and hot tub with lounge chairs and umbrellas at an apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_SwimmingPoolSpa(1).jpg"
    },
    {
      "id": "ec_80831cd9b1aca8c8500e4846",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d497f-928b-738d-8e61-7bcf4a227af6.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas next to a building with a covered patio.",
        "public_id": "019d497f-928b-738d-8e61-7bcf4a227af6",
        "storage_key": "property/6767906449166884/019d497f-928b-738d-8e61-7bcf4a227af6.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable seating areas.",
      "link": "false",
      "alt_text": "Swimming pool with lounge chairs and umbrellas next to a building with a covered patio.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_SwimmingPoolClubhouseView.jpg"
    },
    {
      "id": "ec_cab3bdaef932357ad57e7f93",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d497f-b64f-772c-a981-e60a25b10bd0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "019d497f-b64f-772c-a981-e60a25b10bd0",
        "storage_key": "property/6767906449166884/019d497f-b64f-772c-a981-e60a25b10bd0.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing and unwinding.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and surrounding buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_SwimmingPoolFurniture.jpg"
    },
    {
      "id": "ec_51512152ee7a63918a35a381",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d497f-c265-760a-871d-082527db5699.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019d497f-c265-760a-871d-082527db5699",
        "storage_key": "property/6767906449166884/019d497f-c265-760a-871d-082527db5699.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for sunny days.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_SwimmingPoolDeck.jpg"
    },
    {
      "id": "ec_6f1c9e954721b5293ff998f8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d497f-9a42-747e-bb29-4bcd7b9e98e9.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structure.",
        "public_id": "019d497f-9a42-747e-bb29-4bcd7b9e98e9",
        "storage_key": "property/6767906449166884/019d497f-9a42-747e-bb29-4bcd7b9e98e9.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the community playground, featuring a modern play structure and ample space for children to play.",
      "link": "false",
      "alt_text": "Playground with slides and climbing structure.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_OutdoorPlayground.jpg"
    },
    {
      "id": "ec_a010a31abba319f58cea00f2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d497f-9db5-7365-89c0-48cad375ae7c.webp",
      "image_media": {
        "alt_text": "Playground with swings and apartment buildings in the background.",
        "public_id": "019d497f-9db5-7365-89c0-48cad375ae7c",
        "storage_key": "property/6767906449166884/019d497f-9db5-7365-89c0-48cad375ae7c.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation at our community playground, featuring swings for children and spacious green areas.",
      "link": "false",
      "alt_text": "Playground with swings and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_PlaygoundSwingSet.jpg"
    },
    {
      "id": "ec_1136382e8dc89398ceeb2260",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d497f-c787-77d8-8f95-875cd3bfa3d6.webp",
      "image_media": {
        "alt_text": "Playground with slide, picnic table, and benches.",
        "public_id": "019d497f-c787-77d8-8f95-875cd3bfa3d6",
        "storage_key": "property/6767906449166884/019d497f-c787-77d8-8f95-875cd3bfa3d6.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at the playground, complete with a slide and picnic area.",
      "link": "false",
      "alt_text": "Playground with slide, picnic table, and benches.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_PlaygroundPicnicArea.jpg"
    },
    {
      "id": "ec_0821085ae7b0b27e4b25ad4a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d497f-bc47-71bc-864a-95876a1ab736.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with picnic tables under a wooden pergola.",
        "public_id": "019d497f-bc47-71bc-864a-95876a1ab736",
        "storage_key": "property/6767906449166884/019d497f-bc47-71bc-864a-95876a1ab736.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and relaxation in our community's shaded picnic area, perfect for gatherings.",
      "link": "false",
      "alt_text": "Outdoor seating area with picnic tables under a wooden pergola.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_BBQPicnicArea.jpg"
    },
    {
      "id": "ec_9a857268ff3f400aedfa263e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d497f-ddd5-756e-b7e0-8e789fd9ede8.webp",
      "image_media": {
        "alt_text": "A paved walkway leads through manicured landscaping towards apartment buildings. A fence and trees are visible to the left.",
        "public_id": "019d497f-ddd5-756e-b7e0-8e789fd9ede8",
        "storage_key": "property/6767906449166884/019d497f-ddd5-756e-b7e0-8e789fd9ede8.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Enjoy a stroll along the beautifully landscaped pathways that wind through the community, offering a serene escape amidst lush greenery and charming apartment exteriors.",
      "link": "false",
      "alt_text": "A paved walkway leads through manicured landscaping towards apartment buildings. A fence and trees are visible to the left.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_CommunityWalkingPath.jpg"
    },
    {
      "id": "ec_6e70a98f0346a3237d2a618b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d497f-eb14-7769-a134-145e1058ccfd.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and trees.",
        "public_id": "019d497f-eb14-7769-a134-145e1058ccfd",
        "storage_key": "property/6767906449166884/019d497f-eb14-7769-a134-145e1058ccfd.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Beautifully maintained apartment exteriors with lush green spaces and mature trees, offering a serene living environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_BuildingExteriorsGreenSpace.jpg"
    },
    {
      "id": "ec_abeca86e9f4569e5eef0134b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4980-1cc4-7392-8fa3-728f7c720ea0.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with balconies and stairs.",
        "public_id": "019d4980-1cc4-7392-8fa3-728f7c720ea0",
        "storage_key": "property/6767906449166884/019d4980-1cc4-7392-8fa3-728f7c720ea0.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "View of the exterior of the apartment building, showcasing its architecture and surrounding landscaping.",
      "link": "false",
      "alt_text": "Exterior of apartment building with balconies and stairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_BuildingExteriors(1).jpg"
    },
    {
      "id": "ec_be70ba173f5fb6a19a17b081",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4980-0675-712d-9bc3-f30c6f6b78fc.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with stairs and lush landscaping.",
        "public_id": "019d4980-0675-712d-9bc3-f30c6f6b78fc",
        "storage_key": "property/6767906449166884/019d4980-0675-712d-9bc3-f30c6f6b78fc.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Exterior view of the apartment buildings showcasing the architectural design, external staircases, and well-maintained landscaping.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with stairs and lush landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_BuildingExteriorEntries.jpg"
    },
    {
      "id": "ec_a2d99448f73d11ff9e87439d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d4980-067b-74bd-945d-93ddb848e99a.webp",
      "image_media": {
        "alt_text": "Multiple attached garage doors with numbered bays.",
        "public_id": "019d4980-067b-74bd-945d-93ddb848e99a",
        "storage_key": "property/6767906449166884/019d4980-067b-74bd-945d-93ddb848e99a.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Community",
      "description": "Attached garage bays with grey doors, some numbered, set against a building with siding and a tiled roof.",
      "link": "false",
      "alt_text": "Multiple attached garage doors with numbered bays.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/CanterburyDowns_Roseville_CA_GarageExteriors.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_b701ae19-4905-46f7-96b3-a678eb261332",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Topgolf Roseville",
      "poi_type": "Restaurants",
      "poi_address": "1700 Freedom Wy, Roseville, CA 95678, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "People say this restaurant offers fun golfing games, delicious appetizers, and a variety of cocktails. They highlight the reasonable prices, especially on weekdays, and the lively, high-energy atmosphere, perfect for date nights, family outings, and group gatherings. They also like the friendly and attentive service provided by the staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-98fb-71af-af2f-2b87a5367923.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-98fb-71af-af2f-2b87a5367923",
        "storage_key": "property/6767906449166884/019d08ab-98fb-71af-af2f-2b87a5367923.webp",
        "width": 1000,
        "height": 668
      },
      "poi_business_url": "https://topgolf.com/us/roseville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1683471834520779019&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-roseville",
      "poi_latitude": "38.7908306",
      "poi_longitude": "-121.2959577",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-200-1002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-a7de-77ca-915e-6006a6948d25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a7de-77ca-915e-6006a6948d25",
        "storage_key": "property/6767906449166884/019d08ab-a7de-77ca-915e-6006a6948d25.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9QyJuochm4ARC3n8zbbkXBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_061baef1-0b11-4522-b479-6288906bb790",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "In-N-Out Burger",
      "poi_type": "Restaurants",
      "poi_address": "1803 Taylor Rd, Roseville, CA 95661, USA",
      "poi_short_description": "Classic burger chain serving customizable burgers, hand-cut fries & shakes.",
      "poi_long_description": "People say this hamburger restaurant serves delicious animal fries, grilled cheese, and milkshakes. They highlight the fresh ingredients, affordable prices, and fast service. They also like the friendly staff and clean environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-0fe5-7199-b4f9-c3590052a746.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0fe5-7199-b4f9-c3590052a746",
        "storage_key": "property/6767906449166884/019d08ac-0fe5-7199-b4f9-c3590052a746.webp",
        "width": 1280,
        "height": 1206
      },
      "poi_business_url": "https://locations.in-n-out.com/132",
      "poi_directions_map_url": "https://maps.google.com/?cid=2664504733912924521&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-n-out-burger",
      "poi_latitude": "38.758269",
      "poi_longitude": "-121.259566",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-786-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-a7de-77ca-915e-6006a6948d25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a7de-77ca-915e-6006a6948d25",
        "storage_key": "property/6767906449166884/019d08ab-a7de-77ca-915e-6006a6948d25.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJv6GYqs-XwoARaQE6N_A4-iQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hamburger_restaurant"
    },
    {
      "id": "custom_5b2ab6b6-06ab-4a4a-8cee-6154c383ffdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "1127 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant serves delicious cheesecake, pasta, and other dishes, with a huge variety of options. They also highlight the friendly and attentive service, and the generous portions.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-0450-705f-8959-0591791cbe5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-0450-705f-8959-0591791cbe5d",
        "storage_key": "property/6767906449166884/019d08ab-0450-705f-8959-0591791cbe5d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ca/roseville-140.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=3096057595972049366&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "38.773032",
      "poi_longitude": "-121.2685074",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-781-3399",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-a7de-77ca-915e-6006a6948d25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a7de-77ca-915e-6006a6948d25",
        "storage_key": "property/6767906449166884/019d08ab-a7de-77ca-915e-6006a6948d25.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi038SdQhm4AR1lkQ3Ppn9yo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a62d0453-b054-4d66-bbb6-09ce1b6a9548",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Yard House",
      "poi_type": "Restaurants",
      "poi_address": "1166 Roseville Pkwy Bldg E, Roseville, CA 95678, USA",
      "poi_short_description": "High-end sports-bar chain with a huge menu of New American fare & an extensive list of draft beers.",
      "poi_long_description": "People say this restaurant offers a wide variety of appetizers, including vampire tacos, sliders, and wings, as well as steak bowls and salmon. They also highlight the quick service, delicious drinks, and fun, lively atmosphere, and like the extensive selection of draft beers and ciders.\n\nOther reviews mention the noise level can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-0db6-7710-80b7-e2939e807e8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-0db6-7710-80b7-e2939e807e8c",
        "storage_key": "property/6767906449166884/019d08ab-0db6-7710-80b7-e2939e807e8c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.yardhouse.com/locations/ca/roseville/roseville-the-fountains/8331?cmpid=br:yh_ag:ie_ch:loc_ca:YHGMB_sn:gmb_gt:roseville-ca-8331_pl:locurl_rd:1029",
      "poi_directions_map_url": "https://maps.google.com/?cid=5817699224790651083&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "yard-house",
      "poi_latitude": "38.76887",
      "poi_longitude": "-121.270022",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-780-9273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-a7de-77ca-915e-6006a6948d25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a7de-77ca-915e-6006a6948d25",
        "storage_key": "property/6767906449166884/019d08ab-a7de-77ca-915e-6006a6948d25.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJC4fub9Ehm4ARy1C2F5-evFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_6b89112e-0a80-443e-8ae1-fffabc902e1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1220 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Fast-food chain specializing in fried chicken fingers, crinkle-cut fries & Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers, fried chicken, and garlic toast. They also highlight the fresh food, quick service, and friendly staff.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-1227-75dc-bb32-049da648421e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-1227-75dc-bb32-049da648421e",
        "storage_key": "property/6767906449166884/019d08ac-1227-75dc-bb32-049da648421e.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ca/roseville/1220-galleria-boulevard",
      "poi_directions_map_url": "https://maps.google.com/?cid=14438597957049205901&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "38.7736002",
      "poi_longitude": "-121.2651215",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-547-5425",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-a7de-77ca-915e-6006a6948d25.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a7de-77ca-915e-6006a6948d25",
        "storage_key": "property/6767906449166884/019d08ab-a7de-77ca-915e-6006a6948d25.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdw1hb1whm4ARjUSZzFc0YMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_9302e3a3-6058-4e73-8223-c143e579fdec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Westfield Galleria at Roseville",
      "poi_type": "Shopping & Retail",
      "poi_address": "1151 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Sprawling shopping mall boasting top-name stores and eateries alongside family-friendly amenities.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including luxury brands and budget-friendly options, as well as a movie theater, play area, and food court with diverse dining choices. They highlight the clean, spacious, and well-organized layout, and the convenient parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-2f3b-768c-9d23-34203a7058dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-2f3b-768c-9d23-34203a7058dc",
        "storage_key": "property/6767906449166884/019d08ab-2f3b-768c-9d23-34203a7058dc.webp",
        "width": 800,
        "height": 450
      },
      "poi_business_url": "https://www.westfield.com/en/united-states/galleriaatroseville",
      "poi_directions_map_url": "https://maps.google.com/?cid=5852009108560938456&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "westfield-galleria-at-roseville",
      "poi_latitude": "38.773542",
      "poi_longitude": "-121.26924",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-787-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-a7f2-7700-aa3f-dbd570cf2655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a7f2-7700-aa3f-dbd570cf2655",
        "storage_key": "property/6767906449166884/019d08ab-a7f2-7700-aa3f-dbd570cf2655.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhTBR8Fked0AR2AUgakeDNlE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_94f1287d-a1f4-4182-93ef-c653329e55b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "1001 Galleria Blvd, Roseville, CA 95678, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy food, fresh produce, and amazing snacks. They also highlight the clean, bright, and welcoming atmosphere, and the helpful and friendly staff.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-3250-71cc-8c78-88044ee7d378.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-3250-71cc-8c78-88044ee7d378",
        "storage_key": "property/6767906449166884/019d08ab-3250-71cc-8c78-88044ee7d378.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/roseville?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=30447028617915124&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "38.7673904",
      "poi_longitude": "-121.2672481",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-781-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-a7fa-73fd-b379-2a1e49f4a7b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a7fa-73fd-b379-2a1e49f4a7b0",
        "storage_key": "property/6767906449166884/019d08ab-a7fa-73fd-b379-2a1e49f4a7b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtS4AVtQhm4AR9Ko8RWkrbAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_d32dbd3d-3792-441c-b537-f313fe736cf7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "10151 Fairway Dr WinCo, Roseville, CA 95678, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide variety of fresh produce, meats, and bulk foods, including an extensive selection of grains, nuts, and snacks. They highlight the low prices, great deals, and the well-stocked shelves. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-13cd-716e-9168-b2ce66fb005a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-13cd-716e-9168-b2ce66fb005a",
        "storage_key": "property/6767906449166884/019d08ac-13cd-716e-9168-b2ce66fb005a.webp",
        "width": 1280,
        "height": 884
      },
      "poi_business_url": "http://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3355687902784976035&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "38.7851269",
      "poi_longitude": "-121.27854",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-783-6090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-a7fa-73fd-b379-2a1e49f4a7b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a7fa-73fd-b379-2a1e49f4a7b0",
        "storage_key": "property/6767906449166884/019d08ab-a7fa-73fd-b379-2a1e49f4a7b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSxH4Fekhm4ARo_SSTl7MkS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_01340df4-c402-470c-a927-c5b2565e413e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1117 Roseville Square, Roseville, CA 95678, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide variety of unique and delicious foods, including organic produce and European imports. They highlight the affordable prices and the fun, lively atmosphere with music and singing shoppers. They also like the friendly, helpful staff who provide excellent service, even carrying heavy bags to cars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-216a-753d-b79a-6ef565af45af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-216a-753d-b79a-6ef565af45af",
        "storage_key": "property/6767906449166884/019d08ab-216a-753d-b79a-6ef565af45af.webp",
        "width": 1280,
        "height": 1174
      },
      "poi_business_url": "https://locations.traderjoes.com/ca/roseville/80/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=13791252673358186453&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "38.7462886",
      "poi_longitude": "-121.274886",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-784-9084",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-a7fa-73fd-b379-2a1e49f4a7b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a7fa-73fd-b379-2a1e49f4a7b0",
        "storage_key": "property/6767906449166884/019d08ab-a7fa-73fd-b379-2a1e49f4a7b0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYTRdVD0gm4AR1ccruzxfZL8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7e848eae-9262-430e-b597-9fe1282bcf73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "10001 Fairway Dr, Roseville, CA 95678, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has a wide selection of products and equipment rentals. They also highlight the friendly and helpful staff, and the well-maintained garden area.\n\nOther reviews mention the parking lot can be messy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-16bb-7740-80d5-6d5ed655f219.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-16bb-7740-80d5-6d5ed655f219",
        "storage_key": "property/6767906449166884/019d08ac-16bb-7740-80d5-6d5ed655f219.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.homedepot.com/l/Stanford-Ranch/CA/Roseville/95678/6688?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8682696703861530084&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "38.783274",
      "poi_longitude": "-121.2744493",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-787-0201",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-a7f2-7700-aa3f-dbd570cf2655.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-a7f2-7700-aa3f-dbd570cf2655",
        "storage_key": "property/6767906449166884/019d08ab-a7f2-7700-aa3f-dbd570cf2655.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIUrsBeghm4AR5B0fNqYif3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_45c24697-4535-415e-be36-4fb2703f717e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Sierra College",
      "poi_type": "Education",
      "poi_address": "5100 Sierra College Blvd, Rocklin, CA 95677, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-94f0-7696-8f26-a820a0f027ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-94f0-7696-8f26-a820a0f027ea",
        "storage_key": "property/6767906449166884/019d08ab-94f0-7696-8f26-a820a0f027ea.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sierracollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7035051336990397408&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sierra-college",
      "poi_latitude": "38.7909585",
      "poi_longitude": "-121.2108548",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-624-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-ad47-773c-960c-189fb8ace0b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-ad47-773c-960c-189fb8ace0b7",
        "storage_key": "property/6767906449166884/019d08ab-ad47-773c-960c-189fb8ace0b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ737sfwem4AR4BPz7eqFoWE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7c586d8b-6d16-4b72-9fe2-4ce05c9e6f0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Jessup University",
      "poi_type": "Education",
      "poi_address": "2121 University Ave, Rocklin, CA 95765, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-19d2-720c-ac92-f57d9e6cb6aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-19d2-720c-ac92-f57d9e6cb6aa",
        "storage_key": "property/6767906449166884/019d08ac-19d2-720c-ac92-f57d9e6cb6aa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://jessup.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13733206301315708494&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jessup-university",
      "poi_latitude": "38.8203949",
      "poi_longitude": "-121.292457",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-577-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-ad47-773c-960c-189fb8ace0b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-ad47-773c-960c-189fb8ace0b7",
        "storage_key": "property/6767906449166884/019d08ab-ad47-773c-960c-189fb8ace0b7.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrVlwI0cim4ARTjYUkV4mlr4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_60d8eff9-1588-4500-812c-66f15e29a872",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Roseville Golfland Sunsplash",
      "poi_type": "Entertainment",
      "poi_address": "1893 Taylor Rd, Roseville, CA 95661, USA",
      "poi_short_description": "Amusement chain featuring mini golf courses & arcades, some branches with water slides & laser tag.",
      "poi_long_description": "People say this amusement park offers a variety of fun activities, including mini golf, water slides, go-karts, and an arcade. They also highlight the family-friendly atmosphere, the friendly staff, and the well-maintained facilities.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-47d1-7238-807b-14e32a26d9da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-47d1-7238-807b-14e32a26d9da",
        "storage_key": "property/6767906449166884/019d08ab-47d1-7238-807b-14e32a26d9da.webp",
        "width": 1140,
        "height": 755
      },
      "poi_business_url": "http://www.golfland.com/roseville",
      "poi_directions_map_url": "https://maps.google.com/?cid=13763917757911760307&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roseville-golfland-sunsplash",
      "poi_latitude": "38.7615002",
      "poi_longitude": "-121.2579841",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-784-1273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-adeb-7389-bafd-70dbdc375a16",
        "storage_key": "property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfQmp14Ufm4ARs30FxkZCA78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_6062e46c-0714-4abe-abd8-8457e1c0078b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Vernon Street Town Square",
      "poi_type": "Entertainment",
      "poi_address": "311 Vernon St, Roseville, CA 95678, USA",
      "poi_short_description": "Family-friendly event destination featuring a splash pad and concerts throughout the year.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-1ff6-7542-b74d-a9ca606af699.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-1ff6-7542-b74d-a9ca606af699",
        "storage_key": "property/6767906449166884/019d08ac-1ff6-7542-b74d-a9ca606af699.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.roseville.ca.us/parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10388886401199227140&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vernon-street-town-square",
      "poi_latitude": "38.747918",
      "poi_longitude": "-121.2844672",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 916-772-7529",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-adeb-7389-bafd-70dbdc375a16",
        "storage_key": "property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC3cGlzggm4ARBMFdoyO9LJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "plaza"
    },
    {
      "id": "custom_84c08100-7740-4659-9781-fdfa2bb8ef6e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Sierra College Natural History Museum - SCNHM",
      "poi_type": "Entertainment",
      "poi_address": "5100 Sierra College Blvd, Rocklin, CA 95677, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-1fe1-763b-b551-989b4d4dfb8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-1fe1-763b-b551-989b4d4dfb8e",
        "storage_key": "property/6767906449166884/019d08ac-1fe1-763b-b551-989b4d4dfb8e.webp",
        "width": 1280,
        "height": 872
      },
      "poi_business_url": "https://www.sierracollege.edu/campus-life/things-to-do-on-campus/natural-history-museum/",
      "poi_directions_map_url": "https://maps.google.com/?cid=180864048181489185&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sierra-college-natural-history-museum---scnhm",
      "poi_latitude": "38.7907223",
      "poi_longitude": "-121.2138816",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-660-7923",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-b239-729f-a91a-de2cbe6527f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-b239-729f-a91a-de2cbe6527f9",
        "storage_key": "property/6767906449166884/019d08ab-b239-729f-a91a-de2cbe6527f9.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJscOnwvwem4ARIS5_wOSOggI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_96751ce3-578e-4d57-ad06-e1df4147c06a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Maidu Museum & Historic Site",
      "poi_type": "Entertainment",
      "poi_address": "1970 Johnson Ranch Dr, Roseville, CA 95661, USA",
      "poi_short_description": "This Maidu museum features interactive exhibits, tours & trails with historic petroglyphs & mortars.",
      "poi_long_description": "This Maidu museum features interactive exhibits, tours & trails with historic petroglyphs & mortars.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-52af-7798-b7a8-132df5f5be2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-52af-7798-b7a8-132df5f5be2d",
        "storage_key": "property/6767906449166884/019d08ab-52af-7798-b7a8-132df5f5be2d.webp",
        "width": 800,
        "height": 532
      },
      "poi_business_url": "https://www.roseville.ca.us/residents/maidu_museum_historic_site",
      "poi_directions_map_url": "https://maps.google.com/?cid=12030190500831605979&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maidu-museum--historic-site",
      "poi_latitude": "38.73852",
      "poi_longitude": "-121.2457804",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-774-5934",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-b239-729f-a91a-de2cbe6527f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-b239-729f-a91a-de2cbe6527f9",
        "storage_key": "property/6767906449166884/019d08ab-b239-729f-a91a-de2cbe6527f9.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3cp0-Efm4AR27RYloXS86Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_af9f6428-0554-442e-a2cd-87efb85d3820",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Roseville Utility Exploration Center",
      "poi_type": "Entertainment",
      "poi_address": "1501 Pleasant Grove Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "Learning center with creative exhibits on sustainability topics such as energy & water conservation.",
      "poi_long_description": "Learning center with creative exhibits on sustainability topics such as energy & water conservation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-54d7-70bd-b04e-266ef3216862.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-54d7-70bd-b04e-266ef3216862",
        "storage_key": "property/6767906449166884/019d08ab-54d7-70bd-b04e-266ef3216862.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://www.roseville.ca.us/explore",
      "poi_directions_map_url": "https://maps.google.com/?cid=910903833852852384&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "roseville-utility-exploration-center",
      "poi_latitude": "38.7674387",
      "poi_longitude": "-121.332085",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-746-1550",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-b239-729f-a91a-de2cbe6527f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-b239-729f-a91a-de2cbe6527f9",
        "storage_key": "property/6767906449166884/019d08ab-b239-729f-a91a-de2cbe6527f9.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJR8ooIkAhm4ARoDhX8TUupAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_673505de-592b-40fd-a9b8-ac7ab2701667",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "1435 E Roseville Pkwy, Roseville, CA 95661, USA",
      "poi_short_description": "Gym with a cafe, an outdoor pool and spa, plus a mix of classes and personal trainers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-214f-76fa-9e62-fc7016d081b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-214f-76fa-9e62-fc7016d081b7",
        "storage_key": "property/6767906449166884/019d08ac-214f-76fa-9e62-fc7016d081b7.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ca/roseville.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=857371607747484135&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "38.7619047",
      "poi_longitude": "-121.2446626",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-472-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-adeb-7389-bafd-70dbdc375a16",
        "storage_key": "property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-SMM5cfm4AR51lLSO_-5Qs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d2e0bfd6-ca53-4fe2-9a45-c3cbf5248d1f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1533 Blue Oaks Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "Clean 24-hour fitness center offering weight training and cardio machines, plus personal training.",
      "poi_long_description": "People say this gym offers a wide variety of cardio equipment, machines, and classes, including Zumba, and has amenities like a sauna, cold plunge, and hot tub. They also highlight the friendly, energetic, and supportive staff, and the positive and motivating vibe.\n\nSome reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-22a6-7207-b808-4d94004d9f7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-22a6-7207-b808-4d94004d9f7d",
        "storage_key": "property/6767906449166884/019d08ac-22a6-7207-b808-4d94004d9f7d.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/roseville-ca/west-roseville-super-sport",
      "poi_directions_map_url": "https://maps.google.com/?cid=6961004575732605694&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "38.7936837",
      "poi_longitude": "-121.3276887",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 279-399-7106",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-adeb-7389-bafd-70dbdc375a16",
        "storage_key": "property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ag-VlIjm4AR_iJp2Md0mmA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ea6952f3-21ca-40dd-8cf5-0cb15a02d1d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Villa Sport Athletic Club",
      "poi_type": "Health and Wellness",
      "poi_address": "291 Conference Center Dr, Roseville, CA 95678, USA",
      "poi_short_description": "Family-friendly fitness centre featuring a pool with a waterslide, plus a spa and a kids' club.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-2802-7038-bab0-488747ec5cf9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-2802-7038-bab0-488747ec5cf9",
        "storage_key": "property/6767906449166884/019d08ac-2802-7038-bab0-488747ec5cf9.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.villasport.com/roseville/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3436146082975352668&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "villa-sport-athletic-club",
      "poi_latitude": "38.7790663",
      "poi_longitude": "-121.271663",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-831-7070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-adeb-7389-bafd-70dbdc375a16",
        "storage_key": "property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS90qpfghm4ARXIcYMKikry8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_37c49ad9-a123-40e0-9e3e-e266829a749e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "1232 Galleria Blvd Ste 100, Roseville, CA 95678, USA",
      "poi_short_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-2bf8-773b-b183-846176ad2ddf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-2bf8-773b-b183-846176ad2ddf",
        "storage_key": "property/6767906449166884/019d08ac-2bf8-773b-b183-846176ad2ddf.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/roseville-ca-103",
      "poi_directions_map_url": "https://maps.google.com/?cid=5127848378555817095&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "38.773455",
      "poi_longitude": "-121.2612387",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-780-1117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-adeb-7389-bafd-70dbdc375a16",
        "storage_key": "property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0fSv930fm4ARh9zhie7GKUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_90ef0e54-0cc6-4d2f-8da5-0138c7d9460b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1159 Roseville Square Ste 100, Roseville, CA 95678, USA",
      "poi_short_description": "Clean, friendly, well-equipped facility that's part of a chain.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-29dc-767a-aed1-a0e15d9f43c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-29dc-767a-aed1-a0e15d9f43c3",
        "storage_key": "property/6767906449166884/019d08ac-29dc-767a-aed1-a0e15d9f43c3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/roseville-ca?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=11658269411521409879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.7468683",
      "poi_longitude": "-121.2740643",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 916-604-8235",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-adeb-7389-bafd-70dbdc375a16",
        "storage_key": "property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq0EtYWchm4ARVzOJ-UJ-yqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2e19dfc4-f84d-4e79-9814-4582e6e53672",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Gold's Gym - Citrus Heights",
      "poi_type": "Health and Wellness",
      "poi_address": "8485 Auburn Blvd, Citrus Heights, CA 95610, USA",
      "poi_short_description": "Spacious chain gym offering a variety of exercise machines and weights including cardio options, along with friendly staff.",
      "poi_long_description": "People say this gym offers a wide variety of equipment. They highlight the gym is a decent size and the front desk staff is usually friendly. They also like the welcoming atmosphere and the willingness of members to share advice. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-30bc-7333-b561-bcf522230d02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-30bc-7333-b561-bcf522230d02",
        "storage_key": "property/6767906449166884/019d08ac-30bc-7333-b561-bcf522230d02.webp",
        "width": 960,
        "height": 350
      },
      "poi_business_url": "http://www.goldsgym.com/citrus-heights/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11983788150103413449&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golds-gym---citrus-heights",
      "poi_latitude": "38.7203476",
      "poi_longitude": "-121.2916771",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 916-241-8939",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-adeb-7389-bafd-70dbdc375a16",
        "storage_key": "property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfeXk-4nfmoARyRJzZtT3TqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_40fd3949-2df2-4252-b5a2-9aab37d83615",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "In-Shape Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "2165 Sunset Blvd, Rocklin, CA 95765, USA",
      "poi_short_description": "Chain fitness center with a swimming pool, Pilates studio, and yoga studio, plus child care.",
      "poi_long_description": "People say this gym offers a large variety of equipment, a pool, a sauna, and a steam room. They also highlight the friendly staff, the beautiful views, and the good vibe.\n\nOther reviews mention the facilities can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-3194-754c-bd70-122961e6336a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-3194-754c-bd70-122961e6336a",
        "storage_key": "property/6767906449166884/019d08ac-3194-754c-bd70-122961e6336a.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.inshape.com/gyms/rocklin?utm_source=G&utm_medium=Local&utm_campaign=Google-Local&utm_source=G&utm_medium=Local&utm_campaign=Google-Local",
      "poi_directions_map_url": "https://maps.google.com/?cid=18437040336201676890&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "in-shape-fitness",
      "poi_latitude": "38.8067933",
      "poi_longitude": "-121.2731016",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-435-2141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-adeb-7389-bafd-70dbdc375a16",
        "storage_key": "property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv-qDMPkhm4ARWnjZjICG3f8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cb9185bf-2de1-4a7d-ba17-db415caf4a45",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Sutter Roseville Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Medical Plaza Dr, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-590c-765b-a017-99b0e20fba62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-590c-765b-a017-99b0e20fba62",
        "storage_key": "property/6767906449166884/019d08ab-590c-765b-a017-99b0e20fba62.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.sutterhealth.org/find-location/facility/sutter-roseville-medical-center-1043247063",
      "poi_directions_map_url": "https://maps.google.com/?cid=16416276433024432869&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sutter-roseville-medical-center",
      "poi_latitude": "38.7665119",
      "poi_longitude": "-121.2493364",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 916-781-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-b273-701b-92a6-e12c0ad6c84a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-b273-701b-92a6-e12c0ad6c84a",
        "storage_key": "property/6767906449166884/019d08ab-b273-701b-92a6-e12c0ad6c84a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJHZKeApsfm4AR5boJTXBU0uM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_b1ca545e-7cc9-47f8-9fa3-92b24147e764",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Kaiser Permanente Roseville Medical Center - Building C",
      "poi_type": "Health and Wellness",
      "poi_address": "1660 Eureka Rd, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-3320-769c-9300-9c4eeafaf467.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-3320-769c-9300-9c4eeafaf467",
        "storage_key": "property/6767906449166884/019d08ac-3320-769c-9300-9c4eeafaf467.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thrive.kaiserpermanente.org/care-near-you/northern-california/northvalley/locations/roseville-medical-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12837480181016674950&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kaiser-permanente-roseville-medical-center---building-c",
      "poi_latitude": "38.7455188",
      "poi_longitude": "-121.2488626",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-784-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-b273-701b-92a6-e12c0ad6c84a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-b273-701b-92a6-e12c0ad6c84a",
        "storage_key": "property/6767906449166884/019d08ab-b273-701b-92a6-e12c0ad6c84a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVgDhXMfm4ARhsKdcDXkJ7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_6d5e1d1a-8692-47ea-ae5a-0a5689faa098",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Maidu Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1550 Maidu Dr, Roseville, CA 95661, USA",
      "poi_short_description": "A 152-acre park that includes a community center, library & museum, plus many sports facilities.",
      "poi_long_description": "People say this park offers baseball fields, softball fields, a skate park, walking trails, and a playground. They highlight the spaciousness, shade, and well-maintained facilities, as well as the convenient parking and nearby amenities like a library and community center. They also like the farmers market on Sundays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-7f35-74ce-8bfd-c0da974bfd60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-7f35-74ce-8bfd-c0da974bfd60",
        "storage_key": "property/6767906449166884/019d08ab-7f35-74ce-8bfd-c0da974bfd60.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.roseville.ca.us/government/departments/parks/parks_places/maidu_regional_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=13221982917698702125&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "maidu-regional-park",
      "poi_latitude": "38.7348068",
      "poi_longitude": "-121.2526237",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-774-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-b27a-7643-9882-100eac35d7c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-b27a-7643-9882-100eac35d7c7",
        "storage_key": "property/6767906449166884/019d08ab-b27a-7643-9882-100eac35d7c7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5xooih3gmoARLcu2G2nrfbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bf60add0-1539-4091-ad56-ab6c7b6b3625",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Johnson-Springview Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5480 5th St, Rocklin, CA 95677, USA",
      "poi_short_description": "This expansive community resource features sport courts & fields, a playground & a dog park.",
      "poi_long_description": "People say this park offers a wide variety of activities, including a disc golf course, dog park, pickleball courts, playground, skate park, soccer field, splash pad, tennis courts, and walking trails. They highlight the park's spaciousness, well-maintained facilities, and family-friendly atmosphere. They also like the clean restrooms and shaded BBQ areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-395a-7698-b7ac-e3c6874d7091.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-395a-7698-b7ac-e3c6874d7091",
        "storage_key": "property/6767906449166884/019d08ac-395a-7698-b7ac-e3c6874d7091.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rocklin.ca.us/depts/parksnrec/parks/johnson_springview_park.asp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17091168952253734584&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "johnson-springview-park",
      "poi_latitude": "38.7900911",
      "poi_longitude": "-121.2447255",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 916-625-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-b27a-7643-9882-100eac35d7c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-b27a-7643-9882-100eac35d7c7",
        "storage_key": "property/6767906449166884/019d08ab-b27a-7643-9882-100eac35d7c7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkxyn8Gkfm4ARuN5E85sHMO0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_82796d55-cc69-4e63-8260-34221e33b7ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Rusch Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7801 Auburn Blvd, Citrus Heights, CA 95610, USA",
      "poi_short_description": "Outdoor skating & biking spot with concrete surface, numerous unique features & lighting at night.",
      "poi_long_description": "People say this park offers a wide variety of amenities, including pickleball courts, tennis courts, a swimming pool, playgrounds, and walking trails. They also highlight the clean and well-maintained grounds, and the spacious open areas perfect for picnics and recreational activities.\n\nOther reviews mention there can be homeless people.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-3b4a-77c8-9066-4e7b1271e101.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-3b4a-77c8-9066-4e7b1271e101",
        "storage_key": "property/6767906449166884/019d08ac-3b4a-77c8-9066-4e7b1271e101.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sunriseparks.com/rusch-community-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=352438582190195855&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rusch-community-park",
      "poi_latitude": "38.70897069999999",
      "poi_longitude": "-121.2912232",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-b27a-7643-9882-100eac35d7c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-b27a-7643-9882-100eac35d7c7",
        "storage_key": "property/6767906449166884/019d08ab-b27a-7643-9882-100eac35d7c7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCebD9pDfmoARj8SW8AUd5AQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e9003ab4-c50f-4082-b438-b033cc9b11ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Harry Crabb Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 Scarborough Dr, Roseville, CA 95661, USA",
      "poi_short_description": "Popular family park featuring a splash pad, as well as swings and sand volleyball courts.",
      "poi_long_description": "Visitors say this park has a great splash pad and water park, as well as volleyball courts, a baseball field, a basketball court, a tennis court, a playground, a picnic area, and soccer fields. They also highlight that the park is clean and well-maintained, with bathrooms available.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-3d29-755e-b65b-2a2d5ace0677.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-3d29-755e-b65b-2a2d5ace0677",
        "storage_key": "property/6767906449166884/019d08ac-3d29-755e-b65b-2a2d5ace0677.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.roseville.ca.us/government/departments/parks/parks_places/crabb_park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15538028085356412488&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "harry-crabb-park",
      "poi_latitude": "38.7691293",
      "poi_longitude": "-121.2346673",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 916-774-5748",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-b27a-7643-9882-100eac35d7c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-b27a-7643-9882-100eac35d7c7",
        "storage_key": "property/6767906449166884/019d08ab-b27a-7643-9882-100eac35d7c7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJk348haMfm4ARSD62OTgqotc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0f0cf5ac-75bc-4a27-8922-02d9ca9cf553",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Gibson Ranch Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8556 Gibson Ranch Park Rd, Elverta, CA 95626, USA",
      "poi_short_description": "Large park with nature trails, farm animals, horseback riding, camping, outdoor concerts & events.",
      "poi_long_description": "People say this park offers fishing, picnic areas, and walking trails. They highlight the spacious green grass, beautiful views, and family-friendly atmosphere. They also like the ample parking, well-maintained facilities, and availability of barbecue pits and seating for large groups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-3ba6-70ba-a7d2-60686637ec18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-3ba6-70ba-a7d2-60686637ec18",
        "storage_key": "property/6767906449166884/019d08ac-3ba6-70ba-a7d2-60686637ec18.webp",
        "width": 1280,
        "height": 768
      },
      "poi_business_url": "http://regionalparks.saccounty.net/Parks/RegionalParksDetails/Pages/GibsonRanch.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=6179385611734743009&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "gibson-ranch-regional-park",
      "poi_latitude": "38.723755",
      "poi_longitude": "-121.4034049",
      "poi_miles_from_property": "10.5",
      "poi_walking_minutes": "3 hours 50 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 916-875-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-b27a-7643-9882-100eac35d7c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-b27a-7643-9882-100eac35d7c7",
        "storage_key": "property/6767906449166884/019d08ab-b27a-7643-9882-100eac35d7c7.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJUOh66snm4AR4febXXmWwVU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_dec78484-e967-4c54-9e79-4bb6dfe9f679",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Adventist Health Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One Adventist Health Way, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-4201-704a-885f-24c1768c6731.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-4201-704a-885f-24c1768c6731",
        "storage_key": "property/6767906449166884/019d08ac-4201-704a-885f-24c1768c6731.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://adventisthealth.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7527772297905000202&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "adventist-health-corporate-office",
      "poi_latitude": "38.7569855",
      "poi_longitude": "-121.2519719",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 916-406-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-adeb-7389-bafd-70dbdc375a16",
        "storage_key": "property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJncKXiO8fm4ARCk-nZgUFeGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_75a262a4-56b3-43cc-9cd8-867ad92440b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Hewlett Packard Enterprise",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8000 Foothills Blvd, Roseville, CA 95747, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-9583-73dd-9818-b5e7dccfe924.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-9583-73dd-9818-b5e7dccfe924",
        "storage_key": "property/6767906449166884/019d08ab-9583-73dd-9818-b5e7dccfe924.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.hpe.com/us/en/home.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=11168594821131035904&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hewlett-packard-enterprise",
      "poi_latitude": "38.7849688",
      "poi_longitude": "-121.3163292",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 888-342-2156",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-adeb-7389-bafd-70dbdc375a16",
        "storage_key": "property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJURi8130hm4ARAGXI6dDR_po",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a58ecf28-be02-46b9-b195-51068293a942",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Alta California Regional Center - Roseville",
      "poi_type": "Major Employers & Offices",
      "poi_address": "516 Gibson Dr #150, Roseville, CA 95678, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.altaregional.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16993152713332891207&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "alta-california-regional-center---roseville",
      "poi_latitude": "38.779814",
      "poi_longitude": "-121.2730978",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 916-437-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-adeb-7389-bafd-70dbdc375a16",
        "storage_key": "property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ47RgO_Yfm4ARRx4s9FvO0-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2a4218be-cbeb-4952-94c2-83edc1ef950f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "Norcanna Farms Cannabis Delivery",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6929 Sunrise Blvd, Citrus Heights, CA 95610, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ac-4455-71fb-a518-1047a00fc34b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-4455-71fb-a518-1047a00fc34b",
        "storage_key": "property/6767906449166884/019d08ac-4455-71fb-a518-1047a00fc34b.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://norcannafarms.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13645295156685364849&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "norcanna-farms-cannabis-delivery",
      "poi_latitude": "38.69166260000001",
      "poi_longitude": "-121.2721073",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 916-671-3446",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-adeb-7389-bafd-70dbdc375a16",
        "storage_key": "property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUxpQROffmoARcd6WLabTXb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_5ed45e2b-0312-4969-9bba-02f9ffb850a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "poi_name": "KRATOS",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2901 Douglas Blvd STE 105, Roseville, CA 95661, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.kratosusd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=313016841676869165&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "kratos",
      "poi_latitude": "38.74523629999999",
      "poi_longitude": "-121.2387311",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 916-991-1990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ab-adeb-7389-bafd-70dbdc375a16",
        "storage_key": "property/6767906449166884/019d08ab-adeb-7389-bafd-70dbdc375a16.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ8lKct0fm4ARLU7duCgPWAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_316162f3-e904-4337-abeb-c5f24df26f01",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_0058e825-cbc2-40c2-a843-d18302da4c0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_3038eecf-6872-4dfc-b538-c11e7b828bed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_f5102401-8113-4001-b5ce-538a2450094f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_19e7f33a-201f-47f9-8d99-c6e43f9f29c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "custom_55d469b9-49a9-4924-a0b4-ad9479de923e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_a42525f2-b5cf-43e3-a4e8-d3181fec24bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "rating": "5.0",
      "name": "Alaina Rutman",
      "text": "I can’t express how happy we are to have chosen Canterbury Downs as our first home in CA. Nick and Ed made the process so easy and painless. Which says A LOT. We moved from FL and completed everything over the phone and online. They were so patient with me through alllllll of my questions and always took the next call with enthusiasm. They have been just as friendly in person now that we are here and settled in.\n\nThe community is well kept and quiet with friendly neighbors. We are a 10 minute drive of everything! Shopping, dining, entertainment, everything we could possibly need is super close by.\n\nIt's not super luxurious, but our unit was recently renovated and is very nice with everything we need to start our lives in CA in comfort. Definitely recommend!",
      "date": "2018-10-09",
      "title": ""
    },
    {
      "id": "custom_dec2af51-8c66-406c-961b-3ccf48882fa8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "rating": "5.0",
      "name": "Marina A",
      "text": "Update: probably will be my last one for awhile but I just have to say how amazing this complex at maintenance requests. Literally get everything done the same day as you report it (within reason of course). This is the first place ive ever lived at that goes out of their way to CALL you after you EMAIL them a request. Literally called me the same day to inform me its been addressed! Who does that?! This is absolutely amazing. I've never felt before like the management truly cares. And ive lived in 10 apartments in the last 12 years. So I know what im talking about. I am loving this place and probably will be staying here for a very long time. I jusy seriously have zero complaints so far. Not a single bad thing.\n\nUpdate: I've lived here for 2 months now and I absolutely love it! Despite having kids all around me, I actually never hear them. The walls are definitely thick enough. This complex also feels very safe. The grounds are clean. The office management and the maintenance team are so friendly and attentive. All issues get addressed immediately. Honestly, I've got zero complaints so far. And I've lived in over 10 apartment complexes over the years, so I really do know what I'm talking about.\n\nFirst day: Gerardo is amazing! He was soooo incredibly friendly and helpful. He did my tour, was patients with me, and made the application process so easy. Tbh he is one of the reasons I decided to move here. Having great leasing staff is huge. And Gerardo was just that. So far this review is based on first impressions. I applied for an apartment today, so I will be updating the review after I've lived there for a couple of months. But so far the first impressions are great. Clean grounds, nice apartment, great amenities, and friendly Gerardo!",
      "date": "2025-06-24",
      "title": ""
    },
    {
      "id": "custom_db042f80-1b25-4bd0-ae79-0df0f820b7b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "rating": "5.0",
      "name": "farhad khoshbeen",
      "text": "We are very happy that we chose Canterbury Downs Apartments, our move in process was very smooth and I appreciate the management team at Canterbury Downs Apartments.👏👏",
      "date": "2025-10-29",
      "title": ""
    },
    {
      "id": "custom_9cc33532-ac77-4eb9-91fa-9f9d84a7d8ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "rating": "5.0",
      "name": "Natallia Alfirovich",
      "text": "I very rarely write reviews. But this is a special case. We have been living in this apartment for more than a year and I can give an objective assessment. I would like to mention the work of the apartment managers Angela and Gerardo. They are very attentive and helpful staff. You can contact them with any question, and they will solve it very quickly. They will find an approach to each person. Even after the time has passed, do they check if everything is in order? We really like this attitude. We highly recommend our Canterbury Downs complex. Thanks to Angela and Gerardo.\nNatallia Alfirovich",
      "date": "2024-05-29",
      "title": ""
    },
    {
      "id": "custom_5d78fadc-1c8d-4046-acd1-90fc548f94f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "rating": "5.0",
      "name": "Cynthia Fox",
      "text": "We could not be happier here! Property is immaculate, quiet, peaceful and residents are very friendly. Angela and Gerardo are so wonderful, helpful and responsive and maintenance is very timely and accurate. They made our move in so easy and made us feel welcome from the first time we met them.",
      "date": "2023-02-11",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_c734fccf-647b-485b-b53e-2eda568a68ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d2b21-6dcb-7298-9449-da4309c3996e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b21-6dcb-7298-9449-da4309c3996e",
        "storage_key": "property/6767906449166884/019d2b21-6dcb-7298-9449-da4309c3996e.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Canterbury Downs Apartments - Pool & Spa",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ztAAecDT5vM"
    },
    {
      "id": "custom_8adcfeb8-ccd9-4008-b21b-c9cb2e750d55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d2b21-c347-76be-b2f5-1c465470bfe7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b21-c347-76be-b2f5-1c465470bfe7",
        "storage_key": "property/6767906449166884/019d2b21-c347-76be-b2f5-1c465470bfe7.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Canterbury Downs Apartments - Fitness Center & Racquetball",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=szBFmfpJMAi"
    },
    {
      "id": "custom_d651bcef-9c98-4062-a22d-5fbb596b9312",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d2b21-31be-76f4-8983-cc77f1a4f622.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b21-31be-76f4-8983-cc77f1a4f622",
        "storage_key": "property/6767906449166884/019d2b21-31be-76f4-8983-cc77f1a4f622.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Canterbury Downs Apartments - 1 Bedroom 1 Bath 645 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=psN8nAA8gv9"
    },
    {
      "id": "custom_d9e2c7c3-ddc6-4e69-a254-21dc86988fe1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166884/019d2b21-4b52-70ef-99ae-33a9e625bad2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019d2b21-4b52-70ef-99ae-33a9e625bad2",
        "storage_key": "property/6767906449166884/019d2b21-4b52-70ef-99ae-33a9e625bad2.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Canterbury Downs Apartments - 2 Bedroom 1 Bath 841 Sq. Ft.",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=82a6U6X32wv"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019db12d-2cbd-709f-ad7a-1adc8ebb9e2e",
      "lead_source": "LANDING_PAGE",
      "name": "Canterbury Downs Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "generator",
      "page_item_url": "canterbury-downs-apartments-in-unit-laundry",
      "search_query": "apartments with in-unit laundry in Roseville CA",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Roseville, CA",
      "h2_subtitle": "Discover bliss in Roseville, CA with apartments featuring in-unit laundry. Perfect comfort and convenience await you at Canterbury Downs.",
      "page_copy": "Experience the perfect blend of comfort and convenience at Canterbury Downs in the charming Kaseberg - Kingswood neighborhood of Roseville, CA. While our apartments offer centralized heating and air and modern comforts, they ensure you enjoy a stress-free lifestyle. Though we pride ourselves on many amenities such as a basketball court and flexible lease terms, note that every component of our community is tailored to meet your lifestyle needs.\n\nStep outside your door and find a vibrant community equipped with amenities to cater to active lifestyles. Enjoy a match on our racquetball court or relax with a coffee at our cafe seating and coffee bar. Canterbury Downs is not only about living comfortably but also about living stylishly in Roseville, CA. While we don't offer in-unit laundry specifically, our offerings and location make us a prime choice for those seeking a fulfilling apartment lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Canterbury Downs: In-Unit Laundry Apartments",
      "seo_description": "Discover Canterbury Downs in Roseville, CA for ultimate comfort with a range of amenities. Your ideal apartment living experience awaits.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "generator",
      "page_item_url": "canterbury-downs-swimming-pool-apartments",
      "search_query": "swimming pool apartments in Kaseberg-Kingswood",
      "category": "Amenity",
      "h1_title": "Swimming Pool Apartments in Kaseberg-Kingswood",
      "h2_subtitle": "Enjoy apartment living in Kaseberg-Kingswood without a swimming pool. Discover the diverse amenities at Canterbury Downs.",
      "page_copy": "Situated in the inviting neighborhood of Kaseberg-Kingswood, Canterbury Downs brings you a lifestyle of convenience and tranquility. While our community doesn't feature a swimming pool, residents still enjoy a resort-like environment with amenities like a basketball court and a racquetball court, perfect for your active lifestyle.\n\nOur flexible lease terms and centralized heating and air ensure a comfortable and adaptable living experience. Relax with friends at our cafe seating and coffee bar, or explore the vibrant ambiance of Kaseberg-Kingswood. Although a swimming pool isn't available, the overall charm and offerings at Canterbury Downs make it a desirable choice for those seeking quality apartment living in Roseville, CA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Canterbury Downs: Amenities in Kaseberg-Kingswood",
      "seo_description": "Explore Canterbury Downs in Kaseberg-Kingswood, Roseville. Enjoy amenities like racquetball courts and coffee bars, all minus the swimming pool.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "generator",
      "page_item_url": "canterbury-downs-garage-parking-apartments",
      "search_query": "garage parking available Roseville CA apartments",
      "category": "Amenity",
      "h1_title": "Garage Parking Available at Roseville CA Apartments",
      "h2_subtitle": "Explore the convenience of garage parking at Roseville CA apartments. Canterbury Downs ensures ease and comfort in your daily routine.",
      "page_copy": "Canterbury Downs in Roseville, CA rises above the rest in its understanding of the need for convenience and security. While we provide a range of modern amenities, including a basketball court and a contemporary coffee bar, our focus is centered around ensuring residents experience maximum comfort and convenience.\n\nAlthough our community is centrally located making transit a breeze, it's important to note that we don't offer garage parking on-site. However, the benefits of residing in our conveniently situated apartments are numerous. Enjoy flexible lease terms, centralized heating and air, and the beautiful surroundings of the Kaseberg-Kingswood neighborhood, making Canterbury Downs a prime choice for those prioritizing quality living in Roseville.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Canterbury Downs: Roseville Apartments with Parking",
      "seo_description": "Find convenience at Canterbury Downs, Roseville, with prime location amenities, minus garage parking. Discover comfortable living today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "generator",
      "page_item_url": "canterbury-downs-24-hour-fitness-placer-county",
      "search_query": "24-hour fitness center apartments in Placer County",
      "category": "Amenity",
      "h1_title": "24-Hour Fitness Center Apartments in Placer County",
      "h2_subtitle": "Find dynamic living in Placer County at Canterbury Downs, noted for its active lifestyle amenities though lacking a 24-hour fitness center.",
      "page_copy": "Canterbury Downs offers a lively and comfortable apartment living experience in the heart of Placer County. Although our community does not include a 24-hour fitness center, we have a fantastic range of other leisure amenities to keep you engaged and energized, such as a basketball court and a racquetball court.\n\nLocated in the Kaseberg-Kingswood neighborhood of Roseville, we prioritize the comfort and satisfaction of our residents. Enjoy conveniences like centralized heating and air, flexible lease terms, and relaxing spaces like our cafe seating and coffee bar. Whether you're stepping into the vibrant community vibe or enjoying the tranquility within your home, Canterbury Downs offers a balanced lifestyle without the need of a 24-hour fitness center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Canterbury Downs: Active Living in Placer County",
      "seo_description": "Live actively at Canterbury Downs in Placer County. Despite no 24-hour gym, enjoy amenities like racquetball courts and coffee bar.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "generator",
      "page_item_url": "canterbury-downs-central-air-conditioning",
      "search_query": "apartments with central air conditioning in Roseville",
      "category": "Amenity",
      "h1_title": "Apartments with Central Air Conditioning in Roseville",
      "h2_subtitle": "Stay comfortable year-round in Roseville with central air conditioning. Discover the tranquility of Canterbury Downs Apartments.",
      "page_copy": "Nestled in the charming Kaseberg-Kingswood area of Roseville, Canterbury Downs offers homes equipped with central air conditioning to keep you comfortable in all seasons. Our apartments are designed for your comfort and convenience, offering amenities that enhance the quality of everyday living.\n\nBeyond the comfort of temperature-controlled interiors, residents can enjoy a variety of facilities such as a basketball court and a cozy cafe seating and coffee bar. With flexible lease terms and a location that grants easy access to the best of Roseville and Placer County, Canterbury Downs is a stellar choice for those seeking a harmonious blend of comfort and community features, all backed by modern amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Canterbury Downs: Central Air Apartments in Roseville",
      "seo_description": "Experience comfort at Canterbury Downs, Roseville with central air conditioning. Enjoy amenities like basketball courts and coffee bar.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "generator",
      "page_item_url": "canterbury-downs-one-bedroom-roseville",
      "search_query": "one bedroom apartments Roseville CA",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Roseville CA",
      "h2_subtitle": "Discover charming one-bedroom living in Roseville, CA. Canterbury Downs offers spacious layouts with modern amenities.",
      "page_copy": "Welcome to Canterbury Downs, where you can find cozy and stylish one-bedroom apartments right in the heart of Roseville, CA. Each unit is thoughtfully designed to maximize space and comfort, offering an ideal setting whether you're relaxing at home or entertaining guests.\n\nIn addition to the well-appointed one-bedroom layouts, residents at Canterbury Downs enjoy a host of community amenities. Engage in a game of basketball, unwind at our cafe seating with a fresh coffee, or explore the vibrant Kaseberg-Kingswood neighborhood. Our flexible lease terms and modern conveniences, such as centralized heating and air, make living easy and enjoyable in beautiful Placer County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Canterbury Downs: One Bedroom Apartments in Roseville",
      "seo_description": "Find a charming one-bedroom apartment at Canterbury Downs in Roseville, CA. Enjoy modern amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "generator",
      "page_item_url": "canterbury-downs-two-bedroom-placer-county",
      "search_query": "two bedroom apartments Placer County",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Placer County",
      "h2_subtitle": "Explore spacious two-bedroom living in Placer County. Canterbury Downs offers desirable layouts with modern amenities.",
      "page_copy": "At Canterbury Downs, discover the ideal two-bedroom apartment in the welcoming community of Placer County. Our spacious layouts provide ample room for comfortable living, whether you're hosting guests or enjoying a quiet night in. The thoughtfully designed interiors are paired with practical amenities that cater to a modern lifestyle.\n\nOur community boasts a range of activities right at your doorstep. Engage in friendly competition on the basketball and racquetball courts, or relax at our coffee bar with cafe seating. With flexible lease terms and the convenience of centralized heating and air, Canterbury Downs stands out as a premier choice for those seeking a vibrant, amenity-rich living experience in the Kaseberg-Kingswood neighborhood of Roseville.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Canterbury Downs: Two Bedrooms in Placer County",
      "seo_description": "Discover spacious two-bedroom apartments at Canterbury Downs in Placer County. Enjoy modern amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "generator",
      "page_item_url": "canterbury-downs-near-sierra-college",
      "search_query": "apartments near Sierra College Roseville CA",
      "category": "School",
      "h1_title": "Apartments Near Sierra College in Roseville CA",
      "h2_subtitle": "Live close to Sierra College in Roseville, CA. Canterbury Downs offers convenient access and modern living.",
      "page_copy": "Located conveniently near Sierra College in Roseville, CA, Canterbury Downs offers an ideal living environment for students and faculty alike. Our apartments provide the perfect balance of comfort and practicality, with modern amenities that cater to a busy lifestyle.\n\nResidents at Canterbury Downs not only enjoy proximity to Sierra College but also have access to fantastic community features. Take advantage of our basketball and racquetball courts, or enjoy a relaxing moment at our cafe seating and coffee bar. With flexible lease terms and the comfort of centralized heating and air, our homes in the Kaseberg-Kingswood neighborhood are perfectly positioned to offer both convenience and a vibrant living experience in Placer County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Canterbury Downs: Apartments Near Sierra College",
      "seo_description": "Find your ideal apartment near Sierra College at Canterbury Downs in Roseville, CA. Enjoy modern amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "generator",
      "page_item_url": "canterbury-downs-near-jessup-university",
      "search_query": "Roseville apartments close to Jessup University",
      "category": "School",
      "h1_title": "Roseville Apartments Close to Jessup University",
      "h2_subtitle": "Experience living near Jessup University in Roseville. Canterbury Downs offers easy access and a comfortable home atmosphere.",
      "page_copy": "Just a short distance from Jessup University, Canterbury Downs provides an ideal living option for students and faculty seeking Roseville apartments. Offering a blend of spacious interiors and modern amenities, our community caters to those who value convenience and comfort.\n\nIn addition to our prime location, residents can enjoy fun and engaging amenities right on site. Challenge friends on the basketball or racquetball courts, or relax with a coffee in our inviting cafe seating area. With centralized heating and air, as well as flexible lease terms, Canterbury Downs ensures a seamless living experience in the vibrant Kaseberg-Kingswood neighborhood of Placer County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Canterbury Downs: Near Jessup University",
      "seo_description": "Discover Canterbury Downs apartments near Jessup University in Roseville. Enjoy modern amenities and a convenient location for students and faculty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "generator",
      "page_item_url": "canterbury-downs-near-sutter-medical-center",
      "search_query": "apartments near sutter roseville medical center roseville ca",
      "category": "Hospital",
      "h1_title": "Apartments Near Sutter Roseville Medical Center",
      "h2_subtitle": "Convenience meets comfort near Sutter Roseville. Canterbury Downs offers easy access and modern amenities.",
      "page_copy": "Canterbury Downs provides an excellent living choice for healthcare professionals and families seeking apartments near Sutter Roseville Medical Center in Roseville, CA. Our community offers spacious living with amenities that enhance both work and relaxation.\n\nTake advantage of the nearby medical center while enjoying community perks like our basketball and racquetball courts, or unwind at our coffee bar with cafe seating. With flexible lease terms and centralized heating and air, our apartments in the Kaseberg-Kingswood neighborhood of Placer County ensure a comfortable lifestyle close to essential services.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Canterbury Downs: Near Sutter Roseville Medical Center",
      "seo_description": "Live near Sutter Roseville Medical Center at Canterbury Downs. Enjoy modern amenities and easy access to healthcare facilities in Roseville, CA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "generator",
      "page_item_url": "canterbury-downs-near-kaiser-permanente",
      "search_query": "kaseberg kingswood apartments close to kaiser permanente roseville building c",
      "category": "Hospital",
      "h1_title": "Kaseberg Kingswood Apartments Close to Kaiser",
      "h2_subtitle": "Live conveniently close to Kaiser Permanente in Kaseberg-Kingswood. Canterbury Downs offers prime access and superb living quality.",
      "page_copy": "Nestled in the Kaseberg-Kingswood area, Canterbury Downs is the perfect choice for those looking for apartments close to Kaiser Permanente Roseville Building C. Our community ensures easy access to this major healthcare facility while providing a comfortable and modern living experience.\n\nResidents at Canterbury Downs enjoy community amenities like basketball and racquetball courts for recreation, and a cozy cafe seating area with a coffee bar for relaxation. The combination of centralized heating and air conditioning with flexible lease terms ensures that each home caters to diverse lifestyle needs, making it an ideal choice in Placer County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Canterbury Downs: Apartments by Kaiser Permanente",
      "seo_description": "Find Kaseberg-Kingswood apartments near Kaiser Permanente Roseville Building C. Enjoy modern living and convenient healthcare access at Canterbury Downs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "generator",
      "page_item_url": "canterbury-downs-near-maidu-regional-park",
      "search_query": "apartments near maidu regional park roseville",
      "category": "Park",
      "h1_title": "Apartments Near Maidu Regional Park Roseville",
      "h2_subtitle": "Live beside nature at Maidu Regional Park. Canterbury Downs offers unbeatable access and an excellent living experience.",
      "page_copy": "Canterbury Downs is the ideal choice for anyone looking for apartments near Maidu Regional Park in Roseville. Just a short journey away, this serene park offers a lush escape and numerous outdoor activities for recreation and relaxation.\n\nOur community at Canterbury Downs is designed for comfortable living, featuring amenities like basketball and racquetball courts, and a cozy coffee bar with cafe seating. We offer centralized heating and air, along with flexible lease terms, ensuring that every resident enjoys a tailored and pleasant living environment in the Kaseberg-Kingswood neighborhood of Placer County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Canterbury Downs: Near Maidu Regional Park",
      "seo_description": "Live near Maidu Regional Park in Roseville at Canterbury Downs. Enjoy a mix of nature access and modern amenities in a vibrant community setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "generator",
      "page_item_url": "canterbury-downs-near-johnson-springview-park",
      "search_query": "canterbury downs near johnson-springview park",
      "category": "Park",
      "h1_title": "Canterbury Downs Near Johnson-Springview Park",
      "h2_subtitle": "Explore the outdoors at Johnson-Springview Park. Canterbury Downs offers convenient access and superb amenities nearby.",
      "page_copy": "Located just a short drive from Johnson-Springview Park, Canterbury Downs provides the perfect blend of outdoor adventure and comfortable living. Enjoy the park's expansive green spaces and recreational facilities while residing in our well-appointed Roseville community.\n\nAt Canterbury Downs, residents experience the best of both worlds with community amenities such as basketball and racquetball courts, and a welcoming coffee bar with cafe seating. Our flexible lease terms and centralized heating and air ensure that each apartment caters to diverse lifestyles, making it an excellent choice in the Kaseberg-Kingswood neighborhood of Placer County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Canterbury Downs: Near Johnson-Springview Park",
      "seo_description": "Discover Canterbury Downs near Johnson-Springview Park. Experience active living with easy access to outdoor spaces and modern community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "generator",
      "page_item_url": "canterbury-downs-near-rusch-community-park",
      "search_query": "apartments close to rusch community park ca",
      "category": "Park",
      "h1_title": "Apartments Close to Rusch Community Park CA",
      "h2_subtitle": "Discover living close to Rusch Community Park. Enjoy convenience and comfort at Canterbury Downs in Roseville.",
      "page_copy": "Canterbury Downs offers an ideal living experience for those seeking apartments close to Rusch Community Park CA. This vibrant community is conveniently positioned to make the most of the recreational amenities at the park, which is just a short drive away.\n\nOur residents enjoy a wide range of features, including a basketball court, a racquetball court, and a welcoming coffee bar with cafe seating areas. Additionally, with flexible lease terms and centralized heating and air, Canterbury Downs ensures a comfortable living environment tailored to meet your needs in the Kaseberg-Kingswood neighborhood.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Canterbury Downs: Near Rusch Community Park",
      "seo_description": "Find apartments close to Rusch Community Park CA at Canterbury Downs. Experience easy park access and modern community features in Roseville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "generator",
      "page_item_url": "canterbury-downs-near-harry-crabb-park",
      "search_query": "roseville apartments near harry crabb park",
      "category": "Park",
      "h1_title": "Roseville Apartments Near Harry Crabb Park",
      "h2_subtitle": "Enjoy life at Canterbury Downs, near Harry Crabb Park. Perfect for those seeking ease of access and modern amenities.",
      "page_copy": "Nestled in a prime location, Canterbury Downs offers Roseville apartments near Harry Crabb Park. This setup provides the perfect balance of outdoor activity and comfortable living in Roseville.\n\nResidents of Canterbury Downs enjoy modern amenities like a basketball court, racquetball court, and a cozy coffee bar with cafe seating. Our community provides flexible lease terms and centralized heating and air conditioning, making it an appealing choice in the Kaseberg-Kingswood neighborhood. Experience easy access to one of the city's finest parks while enjoying all the comforts of home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Canterbury Downs: Near Harry Crabb Park in Roseville",
      "seo_description": "Live near Harry Crabb Park at Canterbury Downs in Roseville. Enjoy parkside access and a rich set of amenities for a balanced lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166884",
      "source": "generator",
      "page_item_url": "canterbury-downs-near-gibson-ranch-regional-park",
      "search_query": "placer county apartments near gibson ranch regional park",
      "category": "Park",
      "h1_title": "Placer County Apartments Near Gibson Ranch Park",
      "h2_subtitle": "Discover Canterbury Downs close to Gibson Ranch Regional Park. Offering excellent access to nature and modern living amenities.",
      "page_copy": "Canterbury Downs is the perfect choice for those searching for Placer County apartments near Gibson Ranch Regional Park. This location marries the serenity of nature with the conveniences of city living in Roseville.\n\nResidents enjoy top-notch amenities including a basketball court, racquetball court, and a relaxing coffee bar with cafe seating. With flexible lease options and centralized heating and air, Canterbury Downs caters to diverse lifestyle needs while being nestled in the charming Kaseberg-Kingswood neighborhood. Experience easy access to the expansive beauty of Gibson Ranch Regional Park while enjoying modern comforts.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Canterbury Downs: Near Gibson Ranch Regional Park",
      "seo_description": "Find Placer County apartments near Gibson Ranch Park at Canterbury Downs. Enjoy easy access to nature and modern amenities in Roseville.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5975"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372413047"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "\tGTM-WZZ4GXJH"
    },
    {
      "ID": "custom_company_license_number",
      "type": "STRING",
      "value": "#01090130"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-852-7129 "
    }
  ],
  "custom_qb_id": "5975",
  "custom_repli_id": "18372413047",
  "custom_google_gtm_id": "\tGTM-WZZ4GXJH",
  "custom_company_license_number": "#01090130",
  "custom_ppc_tracking_phone_number": "844-852-7129 "
};

export const generatedAt = '2026-09-23T19:57:11.298Z';
